/* eslint-disable react/prop-types, no-use-before-define, no-dupe-keys */
import React, { useEffect, useState } from "react";
import { CButton, CDropdown, CDropdownItem, CDropdownMenu, CDropdownToggle, CFormCheck, CSpinner } from '@coreui/react'
import { CBadge, CFormInput, CFormLabel, CNav, CNavItem, CNavLink, CTabContent, CTabPane, CFormTextarea, CModal, CModalBody, CModalFooter, CModalHeader, CModalTitle } from '@coreui/react'
import Select from 'react-select'
import SaveBoard from "../../../services/general/BoardCrud.api";
import SaveTasks from "../../../services/general/TaskCrud.api";
import { useParams } from "react-router-dom";
import toast from "react-hot-toast";
import CloudinaryUploader from "../../../components/shared/CloudinaryUploader";
import CustomDatePickingFormat from "../../../components/shared/CustomDatePickingFormat";
import { ChevronDown, EllipsisVertical, Paperclip, Pencil, Tag, Trash, X } from "lucide-react";
import RegisterUser from "../../../services/general/register.api";
import ImagingInformation from "../../../services/general/ImagingAPI.api";
import MedicineCRUD from "../../../services/general/Medication.api";
import LabCRUD from "../../../services/general/LabsAPI.api";
import { toastConfig } from "../../../constants/other.config";
import './task-jira-ui.css';
import { getTaskTemplateDefaults, getTaskTemplateLabel, inferTaskTemplateType, TASK_TEMPLATE_OPTIONS, TASK_TEMPLATE_TYPES } from "./taskUtility";
import { findKanbanStatusColumn, normalizeKanbanColumns, toNumericStatusId } from "./kanbanStatusUtils";
import { formatDateToMMDDYYYY, formatValueToISODate, parseUSDateValue } from "../../../components/shared/customDateFormatUtils";

const isArchivedColumnLabel = (label) => String(label || '').trim().toLowerCase() === 'archived'


const UpdateTask = ({ visible, setVisible, fetchBoard, updateTaskId, mode = 'update', taskTemplateType = TASK_TEMPLATE_TYPES.NORMAL, onTaskTemplateTypeChange }) => {
    const isCreateMode = mode === 'create'
    const showPatientDetailsSection = !isCreateMode || taskTemplateType !== TASK_TEMPLATE_TYPES.NEW_ALF_PATIENT
    const resolvedTaskTemplateType = isCreateMode ? taskTemplateType : inferTaskTemplateType(updateTaskId)
    const resolvedTaskTemplateLabel = getTaskTemplateLabel(resolvedTaskTemplateType)
    const { id: routeBoardId } = useParams()
    const [selectedAssignee, setSelectedAssignee] = useState([])
    const [activeKey, setActiveKey] = useState(1);
    const [boardData, setBoardData] = useState(null);
    const [title, setTitle] = useState("");
    const [description, setDescription] = useState("");
    const [collapsedSections, setCollapsedSections] = useState({
        description: false,
        subtasks: false,
        activity: false,
        details: false,
        patientDetails: false,
    });
    const [newSubtaskTitle, setNewSubtaskTitle] = useState('')
    const [showNewSubtaskInput, setShowNewSubtaskInput] = useState(false)
    const [loading, setLoading] = useState(false);
    const [subTasks, setSubTasks] = useState([])
    const [subtaskId, setSubTaskId] = useState(null)
    const [subtaskPendingDelete, setSubtaskPendingDelete] = useState(null)
    const [showDeleteConfirm, setShowDeleteConfirm] = useState(false)
    const [comment, setComment] = useState('')
    const [commentEditId, setCommentEditId] = useState(null)
    const [selectLabs, setSelectLabs] = useState([])
    const [selectMeds, setSelectMeds] = useState([])
    const [selectImaging, setSelectImaging] = useState([])
    const [users, setUsers] = useState([])
    const [prmBoardId, setboardId] = useState(null)
    const [originalTask, setOriginalTask] = useState(null);
    const [isFocused, setIsFocused] = useState(false)
    const [isHovered, setIsHovered] = useState(false)
    const [plusHover, setPlusHover] = useState(false)
    const [statusOptions, setStatusOptions] = useState([])
    const [archiveStatusOption, setArchiveStatusOption] = useState(null)
    const [reminderDateError, setReminderDateError] = useState('')

    const safeStringify = (value) => {
        try {
            return JSON.stringify(value ?? []);
        } catch (err) {
            console.error("JSON stringify failed:", err);
            return "[]";
        }
    };



    const getSelectedBoardId = () => {
        if (routeBoardId) return routeBoardId
        const storedBoardId = localStorage.getItem('selected-board-id')
        if (!storedBoardId) return null

        try {
            const parsedBoardId = JSON.parse(storedBoardId)
            return parsedBoardId || null
        } catch {
            return storedBoardId || null
        }
    }

    const isActive = isFocused || isHovered
    const SUBTASK_STATUS = {
        TODO: 'To Do',
        IN_PROGRESS: 'In Progress',
        DONE: 'Done',
    }

    const safeJson = (value) => {
        if (!value) return []

        if (Array.isArray(value)) return value

        try {
            return JSON.parse(value)
        } catch {
            return []
        }
    }

    const createSubtaskId = () => `${Date.now()}`

    const normalizeSubtaskItem = (subtask = {}, index = 0) => {
        const normalizedStatus = subtask.status ?? subtask.Status ?? (subtask.isCompleted ? SUBTASK_STATUS.DONE : SUBTASK_STATUS.TODO)
        const stableId =
            subtask.id ??
            subtask.Id ??
            subtask.SubtaskId ??
            subtask.subtaskId ??
           `${index}`

        return {
            ...subtask,
            id: String(stableId),
            SubtaskId: subtask.SubtaskId ?? stableId,
            text: subtask.text ?? subtask.Text ?? '',
            status: normalizedStatus,
            dueDate: subtask.dueDate ?? subtask.DueDate ?? '',
            assignee: normalizeSubtaskAssignees(subtask.assignee ?? subtask.Assignee ?? subtask.assignees ?? subtask.AssignedTo),
            isCompleted:
                subtask.isCompleted ??
                subtask.IsCompleted ??
                String(normalizedStatus).trim().toLowerCase() === String(SUBTASK_STATUS.DONE).toLowerCase(),
            checkedBy: subtask.checkedBy ?? subtask.CheckedBy ?? '',
        }
    }

    const normalizeSubtaskList = (subtasks) =>
        safeJson(subtasks).map((subtask, index) => normalizeSubtaskItem(subtask, index))

    const normalizeTask = (task) => {
        return {
            id: String(task?.TaskId ?? task?.id ?? ''),

            boardId: task?.BoardId ?? task?.boardId ?? '',

            title: task?.Title ?? task?.title ?? '',

            description: task?.Description ?? task?.description ?? '',

            status: task?.Status ?? task?.status ?? 'To Do',
            Status: task?.Status ?? task?.status ?? 'To Do',
            statusId: String(task?.StatusId ?? task?.statusId ?? ''),

            StatusId: String(task?.StatusId ?? task?.statusId ?? ''),
            priority: task?.Priority ?? task?.priority ?? 'Low',
            Priority: task?.Priority ?? task?.priority ?? 'Low',

            dueDate:
                task?.DueDate ??
                task?.dueDate ??
                '',

            DueDate:
                task?.DueDate ??
                task?.dueDate ??
                '',

            reminderDate:
                task?.ReminderDate ??
                task?.reminderDate ??
                '',

            ReminderDate:
                task?.ReminderDate ??
                task?.reminderDate ??
                '',

            tags: safeJson(task?.TagsJson ?? task?.tags ?? task?.Tags),

            Tags: safeJson(task?.TagsJson ?? task?.tags ?? task?.Tags),

            comments: safeJson(
                task?.CommentsJson ??
                task?.comments ??
                task?.Comments
            ),

            Comments: safeJson(
                task?.CommentsJson ??
                task?.comments ??
                task?.Comments
            ),

            activities: safeJson(
                task?.ActivityLogsJson ??
                task?.activities ??
                task?.logs
            ),

            logs: safeJson(
                task?.ActivityLogsJson ??
                task?.activities ??
                task?.logs
            ),

            files: safeJson(
    task?.AttachmentsJson ??
    task?.attachments ??
    task?.Attachments
),

  Files: safeJson(
    task?.AttachmentsJson ??    
    task?.attachments ??
    task?.Attachments
),
 

            linkedLabs: safeJson(
                task?.LinkedLabsJson ??
                task?.linkedLabs ??
                task?.labs
            ),

            labs: safeJson(
                task?.LinkedLabsJson ??
                task?.linkedLabs ??
                task?.labs
            ),

            linkedMedications: safeJson(
                task?.LinkedMedicationsJson ??
                task?.linkedMedications ??
                task?.medications
            ),

            medications: safeJson(
                task?.LinkedMedicationsJson ??
                task?.linkedMedications ??
                task?.medications
            ),

            linkedImagings: safeJson(
                task?.LinkedImagingsJson ??
                task?.linkedImagings ??
                task?.imagings
            ),

            imagings: safeJson(
                task?.LinkedImagingsJson ??
                task?.linkedImagings ??
                task?.imagings
            ),

            subtasks: normalizeSubtaskList(
                task?.SubtasksJson ??
                task?.subtasks ??
                task?.subTasks ??
                task?.subtask
            ),

            subTasks: normalizeSubtaskList(
                task?.SubtasksJson ??
                task?.subtasks ??
                task?.subTasks ??
                task?.subtask
            ),

            subtask: normalizeSubtaskList(
                task?.SubtasksJson ??
                task?.subtasks ??
                task?.subTasks ??
                task?.subtask
            ),


            AssignedUsers: safeJson(
                task?.AssignedUsersJson ??
                task?.assignedUsersJson ??
                task?.AssignedUsers ??
                task?.assignedUsers ??
                task?.Assignee ??
                task?.assignee
            ),

            watchers: safeJson(
                task?.WatchersJson ??
                task?.watchers
            ),
            isArchived:
                String(task?.IsArchived ?? task?.isArchived ?? '').trim().toLowerCase() === 'true' ||
                String(task?.Status || '')
                    .trim()
                    .toLowerCase() === 'archived',

            rawTask: task,
        }
    }

    const normalizeSubtaskAssignees = (assignee) => {
        if (!assignee) return []

        if (Array.isArray(assignee)) {
            return assignee
                .map((item) => {
                    if (!item) return null

                    // string case
                    if (typeof item === 'string') {
                        return {
                            UserId: item,
                            value: item,
                            label: item,
                            Username: item,
                        }
                    }

                    const userId =
                        item.UserId ??
                        item.userId ??
                        item.value ??
                        item.id ??
                        ''

                    const username =
                        item.Username ??
                        item.username ??
                        item.label ??
                        item.name ??
                        item.value ??
                        ''

                    return {
                        ...item,

                        UserId: userId,

                        value: String(userId),

                        label: username,

                        Username: username,
                    }
                })
                .filter((item) => item?.value && item?.label)
        }

        // single object
        if (typeof assignee === 'object') {
            const userId =
                assignee.UserId ??
                assignee.userId ??
                assignee.value ??
                assignee.id ??
                ''

            const username =
                assignee.Username ??
                assignee.username ??
                assignee.label ??
                assignee.name ??
                assignee.value ??
                ''

            return userId && username
                ? [
                    {
                        ...assignee,

                        UserId: userId,

                        value: String(userId),

                        label: username,

                        Username: username,
                    },
                ]
                : []
        }

        // plain string
        return String(assignee).trim()
            ? [
                {
                    UserId: assignee,
                    value: assignee,
                    label: assignee,
                    Username: assignee,
                },
            ]
            : []
    }

    const getAssigneeOptionValue = (option) => {
        const id = option?.UserId ?? option?.userId ?? option?.id ?? ''
        const name =
            option?.Username ??
            option?.username ??
            option?.label ??
            option?.name ??
            option?.value ??
            ''

        const matchedUser = users.find((user) => {
            const userId = user?.UserId ?? user?.userId ?? user?.id ?? ''
            const userName =
                user?.Username ??
                user?.username ??
                user?.label ??
                user?.name ??
                user?.value ??
                ''

            return (
                (id && userId && String(userId) === String(id)) ||
                (id && userName && String(userName).toLowerCase() === String(id).toLowerCase()) ||
                (name && userName && String(userName).toLowerCase() === String(name).toLowerCase())
            )
        })

        const matchedId = matchedUser?.UserId ?? matchedUser?.userId ?? matchedUser?.id
        if (matchedId !== undefined && matchedId !== null && String(matchedId).trim() !== '') {
            return String(matchedId)
        }

        if (id !== undefined && id !== null && String(id).trim() !== '') {
            return String(id)
        }

        return String(name).trim()
    }

    const normalizeMedicationSelections = (medications) => {
        if (!Array.isArray(medications)) return []

        return medications
            .map((item) => {
                if (!item) return null

                if (typeof item === 'string') {
                    const trimmed = item.trim()
                    return trimmed ? { value: trimmed, label: trimmed } : null
                }

                const label = String(
                    item?.label ??
                    item?.name ??
                    item?.medicationName ??
                    item?.Name ??
                    item?.value ??
                    ''
                ).trim()

                const value = String(
                    item?.value ??
                    item?.masterMedicationId ??
                    item?.id ??
                    item?.ID ??
                    item?.name ??
                    item?.medicationName ??
                    ''
                ).trim()

                if (!label && !value) return null

                return {
                    ...item,
                    value: value || label,
                    label: label || value,
                }
            })
            .filter((item) => item?.value || item?.label)
    }

    useEffect(() => {
        if (isCreateMode || !updateTaskId) return
        console.log('Raw updateTaskId:', updateTaskId)
        const normalizedTask = normalizeTask(updateTaskId?.rawTask || updateTaskId)
        console.log('Normalized Task:', normalizedTask)
        const normalizedAssignees = normalizeSubtaskAssignees(normalizedTask.AssignedUsers)
        setTitle(normalizedTask.title || '')
        setDescription(normalizedTask.description || '')
        setSubTasks(normalizeSubtaskList(normalizedTask.subtask || []))
        setboardId(normalizedTask.boardId || null)
        const normalizedDueDate = cleanDate(normalizedTask.DueDate)
        const normalizedReminder = cleanDate(normalizedTask.ReminderDate || computeReminderDate(normalizedDueDate))

        const syncedSubtasks = normalizeSubtaskList(normalizedTask.subtask || [])

        const createdById =
            normalizedTask.rawTask?.CreatedBy ??
            normalizedTask.rawTask?.createdBy ??
            ''

        const matchedUser = users.find(
            (u) =>
                String(u?.value) === String(createdById) ||
                String(u?.UserId) === String(createdById) ||
                String(u?.id) === String(createdById)
        )

        const Assigner = matchedUser
            ? {
                UserId:
                    matchedUser.UserId ??
                    matchedUser.id,

                Username:
                    matchedUser.Username ??
                    matchedUser.label,

                value:
                    matchedUser.value ??
                    matchedUser.Username ??
                    matchedUser.label,

                label:
                    matchedUser.label ??
                    matchedUser.Username ??
                    matchedUser.value,

                role:
                    matchedUser.role ?? 'office',
            }
            : null

        const mappedTask = {
            id: normalizedTask.id,

            StatusId: String(
                normalizedTask.StatusId || ''
            ),

            Status:
                normalizedTask.Status || 'To Do',

            subtask: syncedSubtasks,

            Priority:
                normalizedTask.Priority || 'Low',

            Tags: Array.isArray(normalizedTask.Tags)
                ? normalizedTask.Tags
                : [],

            comments: Array.isArray(
                normalizedTask.comments
            )
                ? normalizedTask.comments
                : [],

            files: Array.isArray(normalizedTask.files)
                ? normalizedTask.files
                : [],

            Assignee: normalizedAssignees,


            isArchived:
                Boolean(normalizedTask.isArchived) ||
                String(normalizedTask.Status)
                    .trim()
                    .toLowerCase() === 'archived',

            Assigner,

            DueDate: normalizedDueDate || '',

            reminderDate:
                normalizedReminder || null,

            activities: Array.isArray(
                normalizedTask.activities
            )
                ? normalizedTask.activities
                : [],
        }

        setTask(mappedTask)
        setSelectedAssignee(normalizedAssignees)

        setOriginalTask(mappedTask)

        setSelectLabs(
            Array.isArray(normalizedTask.labs)
                ? normalizedTask.labs
                : []
        )

        setSelectMeds(
            normalizeMedicationSelections(
                Array.isArray(normalizedTask.medications)
                    ? normalizedTask.medications
                    : []
            )
        )

        setSelectImaging(
            Array.isArray(normalizedTask.imagings)
                ? normalizedTask.imagings
                : []
        )



    },  [isCreateMode, updateTaskId, users])

    useEffect(() => {
        if (!isCreateMode) return
        const selectedBoardId = getSelectedBoardId()
        if (selectedBoardId) {
            setboardId(selectedBoardId)
        }
        setActiveKey(1)
    }, [isCreateMode, routeBoardId])

    useEffect(() => {
        if (!isCreateMode || !visible) return
        resetTaskState()
        setActiveKey(0)
    }, [isCreateMode, visible, taskTemplateType])

    useEffect(() => {
        if (!prmBoardId) return;
        const fetchBoard = async () => {
            try {
                const response = await SaveBoard('GET', null, prmBoardId)
                console.log('Raw SaveBoard response:', response)

                const parsed =
                    typeof response?.d === 'string'
                        ? JSON.parse(response.d)
                        : response

                console.log('Parsed response:', parsed)
                const rawData = parsed?.data || []

                const isStatusRow = (item) =>
                    item && typeof item === 'object' &&
                    ('StatusId' in item || 'StatusID' in item || 'statusId' in item || 'StatusName' in item || 'Status' in item || 'name' in item)

                const statusRows = Array.isArray(rawData)
                    ? rawData.every(isStatusRow)
                        ? rawData
                        : Array.isArray(rawData[1]) && rawData[1].every(isStatusRow)
                            ? rawData[1]
                            : []
                    : []

                if (!statusRows.length) {
                    console.error('Unexpected board payload for status rows:', rawData)
                    setBoardData(null)
                    return
                }

                const columns = statusRows.map((status) => ({
                    ...status,
                    keyField: String(
                        status?.StatusId ??
                        status?.StatusID ??
                        status?.statusId ??
                        status?.id ??
                        ''
                    ),
                    headerText:
                        String(
                            status?.StatusName ??
                            status?.Status ??
                            status?.name ??
                            ''
                        ).trim() || 'Untitled',
                }))

                setBoardData({ columns })
                // Ensure statusOptions exist from board columns as a safe fallback
                try {
                    const fallbackOptions = columns
                        .map((c) => ({ value: c.keyField, label: c.headerText }))
                        .filter((o) => o.value !== '')
                    if (fallbackOptions.length) setStatusOptions(fallbackOptions)
                } catch (e) {
                    console.error('Error building fallback status options from columns', e)
                }

            } catch (error) {
                console.error('Fetch board error:', error)
            }
        }

        const fetchStatusList = async () => {
            try {
                const response = await SaveBoard('GET_STATUS_LIST', null, prmBoardId)
                const parsed = typeof response?.d === 'string' ? JSON.parse(response.d) : response
                // Flexible extraction: support multiple payload shapes
                const isStatusRow = (item) =>
                    item && typeof item === 'object' &&
                    ('StatusId' in item || 'StatusID' in item || 'statusId' in item || 'StatusName' in item || 'Status' in item || 'name' in item)

                const extractRows = (raw) => {
                    if (!raw) return []
                    if (Array.isArray(raw)) {
                        if (raw.every(isStatusRow)) return raw
                        if (Array.isArray(raw[0]) && raw[0].every(isStatusRow)) return raw[0]
                        if (Array.isArray(raw[1]) && raw[1].every(isStatusRow)) return raw[1]
                    }
                    return []
                }

                const rawData = parsed?.data ?? parsed ?? parsed?.Data ?? []
                const statusData = extractRows(rawData)
                console.log('Status List:', statusData, parsed, prmBoardId)

                const formattedOptions = statusData
                    .map((item) => ({
                        value: String(item?.StatusId ?? item?.StatusID ?? item?.statusId ?? item?.id ?? ''),
                        label: String(item?.StatusName ?? item?.Status ?? item?.name ?? '').trim() || 'Untitled',
                    }))
                    .filter((option) => option.value !== '')

                // If we couldn't get status list from API, try falling back to boardData.columns
                if (!formattedOptions.length) {
                    const fallback = (boardData?.columns || []).map((c) => ({ value: String(c.keyField), label: c.headerText }))
                    if (fallback.length) {
                        setStatusOptions(fallback)
                        console.log('Falling back to board columns for status options', fallback)
                        return
                    }
                }

                setStatusOptions(formattedOptions)
                console.log('Formatted Status Options:', formattedOptions)
            } catch (error) {
                console.error('Error fetching status list:', error)
                setStatusOptions([])
            }
        }

        fetchBoard();
        fetchStatusList();

    }, [prmBoardId]);

    useEffect(() => {
        if (!boardData) return
        setTask((p) => {
            const matched = findKanbanStatusColumn(boardData?.columns, p.StatusId, p.Status)
            const normalizedColumns = normalizeKanbanColumns(boardData?.columns || [])
            const firstEditableColumn = normalizedColumns.find(
                (column) => !isArchivedColumnLabel(column?.headerText),
            )
            const resolvedColumn =
                isCreateMode && isArchivedColumnLabel(matched?.headerText)
                    ? firstEditableColumn || matched
                    : matched
            return {
                ...p,
                StatusId: resolvedColumn?.keyField ?? p.StatusId,
                Status: resolvedColumn?.headerText ?? p.Status ?? 'To Do',
            }
        })
    }, [boardData, isCreateMode])

    const handleDateChange = (val) => {
        setTask((prev) => {
            if (!val) {
                return {
                    ...prev,
                    DueDate: '',
                    reminderDate: '',
                }
            }
            const previousDefaultReminder = computeReminderDate(prev.DueDate)
            const nextDefaultReminder = computeReminderDate(val)
            const shouldAutoUpdateReminder = !prev.reminderDate || prev.reminderDate === previousDefaultReminder

            return {
                ...prev,
                DueDate: val,
                reminderDate: shouldAutoUpdateReminder ? nextDefaultReminder : prev.reminderDate,
            }
        })
        setReminderDateError('')
    };

    const applyStatusOption = (selectedOption) => setTask((prevState) => ({
        ...prevState,
        Status: selectedOption?.label || null,
        StatusId: selectedOption?.value ?? ''
    }))

    const handleStatusChange = (selectedOption) => {
        if (String(selectedOption?.label || '').trim().toLowerCase() === 'archived') return setArchiveStatusOption(selectedOption)
        applyStatusOption(selectedOption)
    }

    const handleArchiveConfirm = async () => {
        const archiveOption = archiveStatusOption
        if (!archiveOption) return

        const archiveColumn = findKanbanStatusColumn(boardData?.columns, archiveOption?.value, archiveOption?.label)
        if (!archiveColumn || String(archiveColumn?.headerText || '').trim().toLowerCase() !== 'archived') {
            toast.error('Archived column is missing. Please add it to the board first.', toastConfig)
            return
        }

        applyStatusOption({
            value: archiveColumn.keyField,
            label: archiveColumn.headerText,
        })
        setArchiveStatusOption(null)
        await handleCreateTask({
            value: archiveColumn.keyField,
            label: archiveColumn.headerText,
        })
    }

    const handleDeleteSubtaskRequest = (index) => {
        setSubtaskPendingDelete(index)
        setShowDeleteConfirm(true)
    }

    const handleConfirmDeleteSubtask = () => {
        if (subtaskPendingDelete === null) {
            setShowDeleteConfirm(false)
            return
        }

        setTask((prev) => ({
            ...prev,
            subtask: prev.subtask.filter((_, index) => index !== subtaskPendingDelete),
        }))
        setSubtaskPendingDelete(null)
        setShowDeleteConfirm(false)
    }

    const handleCancelDeleteSubtask = () => {
        setSubtaskPendingDelete(null)
        setShowDeleteConfirm(false)
    }

    const formatAssignedUsers = (assignedUsers) => {
        if (!Array.isArray(assignedUsers)) return []

        return assignedUsers
            .map((item) => {
                const id = item?.UserId ?? item?.value ?? item?.id ?? item?.userId

                if (!id) return null

                return {
                    UserId: Number(id),
                }
            })
            .filter(Boolean)
    }

    const handleCreateTask = async (statusOverride = null) => {
        try {
            const missingFields = [];
            if (!title.trim()) missingFields.push("Title");
            if (!description.trim()) missingFields.push("Description");
            if (!task?.Status) missingFields.push("Status");
            if (!task?.Priority) missingFields.push("Priority");
            if (!task?.DueDate) missingFields.push("Due Date");
           // const assignedToCount = Array.isArray(task?.Assignee) ? selectedAssignee.length : 0;
            if (!selectedAssignee.length > 0) missingFields.push("Assigned To");
            if (task.subtask && task.subtask.length > 0) {
                const emptySubtasks = task.subtask.filter(st => !st.text || st.text.trim() === "");
                if (emptySubtasks.length > 0) {
                    toast.error(`Please enter a title for all subtasks. \n ${emptySubtasks.length} subtask(s) have empty title.`, toastConfig, { autoClose: 4000 });
                    toast.error(`Please enter a title for all subtasks. \n ${emptySubtasks.length} subtask(s) have empty title.`, toastConfig, { autoClose: 4000 });
                    return;
                }
            }

            // If missing anything → one toast with all fields
            if (missingFields.length > 0) {
                toast.error(
                    `Please fill in the following fields:\n\n• ${missingFields.join("\n• ")}`,
                    { autoClose: 4000 }
                );
                return;
            }

            const nextStatusId = statusOverride?.value ?? task.StatusId
            const nextStatusLabel = statusOverride?.label ?? task.Status
            const numericTaskStatusId = toNumericStatusId(nextStatusId)
            const selectedStatusColumn =
                findKanbanStatusColumn(boardData?.columns, nextStatusId, nextStatusLabel) ||
                (numericTaskStatusId !== null ? { keyField: numericTaskStatusId, headerText: nextStatusLabel } : null)

            if (!selectedStatusColumn) {
                toast.error("Please select a valid status", toastConfig)
                return;
            }

            const resolvedStatus = selectedStatusColumn.headerText || nextStatusLabel
            const resolvedStatusId = selectedStatusColumn.keyField
            const isArchivedStatus = String(resolvedStatus || '').trim().toLowerCase() === 'archived' || Boolean(task.isArchived)

            if (isCreateMode) {
                const newActivity = {
                    Id: Date.now(),
                    Description: `Task created by ${loggedInUsername}`,
                    CreatedBy: loggedInUsername,
                    CreatedDate: new Date(),
                };

                console.log('[handleCreateTask] CREATE MODE - Subtasks to save:', task.subtask.length, task.subtask)
                console.log('[handleCreateTask] Stringified subtasks:', safeStringify(Array.isArray(task.subtask) ? task.subtask : []))
                setLoading(true);
                const response = await SaveTasks({
                    action: "INSERT",
                    taskId: "",
                    boardId: Number(task.boardId) || Number(prmBoardId),
                    title,
                    description,
                    statusId: resolvedStatusId,
                    status: resolvedStatus,
                    priority: task.Priority,
                    dueDate: task.DueDate || "",
                    reminderDate: task.reminderDate || null,
                    createdBy: loggedInUserId,
                    linkedLabsJson: safeStringify(selectLabs),
                    linkedMedicationsJson: safeStringify(selectMeds),
                    linkedImagingsJson: safeStringify(selectImaging),
                    subtasksJson: safeStringify(Array.isArray(task.subtask) ? task.subtask : []),
                    activityLogsJson: safeStringify([newActivity]),
                    tagsJson: safeStringify(task.Tags),
                    commentsJson: safeStringify(task.comments),
                    watchersJson: "[]",
                    assignedUsersJson: safeStringify(normalizeSubtaskAssignees(task?.Assignee?.length ? task.Assignee : selectedAssignee || [])),
                    attachmentsJson: JSON.stringify(task.files),
                    isArchived: isArchivedStatus,
                    IsArchived: isArchivedStatus

                });


                setLoading(false);

                console.log('Create Task response:', response)
                if (response?.error) {
                    toast.error("Failed to create task");
                    console.error(error);
                    return;
                }

                toast.success("Task created successfully");
                resetTaskState();
                setVisible(false);
                await fetchBoard();
                return;
            }

            const changes = [];

            // ✅ Due Date
            if (cleanDate(task.DueDate) !== cleanDate(originalTask?.DueDate)) {
                changes.push(
                    `updated the Due Date | ${originalTask?.DueDate || "None"} → ${task.DueDate || "None"}`
                );
            }

            // ✅ Priority
            if ((task.Priority || "") !== (originalTask?.Priority || "")) {
                changes.push(
                    `updated the Priority | ${originalTask?.Priority || "None"} → ${task.Priority || "None"}`
                );
            }

            // ✅ Status
            if ((resolvedStatus || "") !== (originalTask?.Status || "")) {
                changes.push(
                    `Updated the Status from| ${originalTask?.Status || "None"} → ${resolvedStatus || "None"}`
                );
            }

            // ✅ Assignee
            if (
                JSON.stringify(task?.Assignee || []) !==
                JSON.stringify(originalTask?.Assignee || [])
            ) {
                changes.push(
                    `changed the Assignee | ${originalTask?.Assignee?.label || "Unassigned"} → ${task.Assignee?.label || "Unassigned"}`
                );
            }

            // ✅ Subtasks
            const normalizeSubtasks = (arr) =>
                (arr || []).map((s) => ({
                    text: s.text,
                    status: s.status,
                }));

            const isSubtaskChanged =
                JSON.stringify(normalizeSubtasks(task.subtask)) !==
                JSON.stringify(normalizeSubtasks(originalTask?.subtask));

            if (isSubtaskChanged) {
                changes.push(`Added   ${task.subtask?.length || 0}  Subtasks `);
            }

            if (
                (task.Assigner?.label || "") !==
                (originalTask?.Assigner?.label || "")
            ) {
                changes.push(
                    `changed the Assigner | ${originalTask?.Assigner?.label || "None"} → ${task.Assigner?.label || "None"}`
                );
            }

            if (cleanDate(task.reminderDate) !== cleanDate(originalTask?.reminderDate)) {
                changes.push(
                    `updated the Reminder Date | ${originalTask?.reminderDate || "None"} → ${task.reminderDate || "None"}`
                );
            }

            let updatedActivities = Array.isArray(task.activities)
                ? [...task.activities]
                : [];

            if (changes.length > 0) {
                const newActivities = changes.map((c) => ({
                    Id: Date.now() + Math.random(),
                    Description: `${c} `,
                    CreatedBy: loggedInUsername,
                    CreatedDate: new Date(),
                }));

                updatedActivities = [...updatedActivities, ...newActivities];
            }


            setLoading(true);

            console.log('[handleCreateTask] UPDATE MODE - Subtasks to save:', task.subtask?.length, task.subtask)
            console.log('[handleCreateTask] Stringified subtasks:', safeStringify(Array.isArray(task.subtask) ? task.subtask : []))
            const response = await SaveTasks({
                action: "UPDATE",
                taskId: updateTaskId?.id ?? updateTaskId?.TaskId ?? updateTaskId?.Id,
                boardId: prmBoardId,
                title,
                description,
                statusId: Number(resolvedStatusId),
                status: resolvedStatus,
                priority: task.Priority,
                dueDate: task.DueDate || "",
                reminderDate: task.reminderDate || null,
                createdBy: loggedInUserId,
                linkedLabsJson: safeStringify(selectLabs),
                linkedMedicationsJson: safeStringify(selectMeds),
                linkedImagingsJson: safeStringify(selectImaging),
                tagsJson: safeStringify(task.Tags),
                commentsJson: safeStringify(task.comments),
                activityLogsJson: safeStringify(updatedActivities),
                watchersJson: "[]",
                assignedUsersJson: safeStringify(
                    normalizeSubtaskAssignees(
                        task?.Assignee?.length
                            ? task.Assignee
                            : selectedAssignee || []
                    )
                ),
                subtasksJson: safeStringify(Array.isArray(task.subtask) ? task.subtask : []),
                attachmentsJson: JSON.stringify(task.files),
                isArchived: isArchivedStatus,
            });
            console.log('Update Task response:', task.files)
            setLoading(false);

            if (response?.error) {
                toast.error("Failed to update task");
                console.error(response?.error, "failed");
                return;
            }


            toast.success("Task update successfully");
            setVisible(false);
            setSelectImaging([])
            setSelectLabs([])
            setSelectMeds([])
            await fetchBoard()
        } catch (error) {
            console.log(error, 'error while updating')
        }
    };


    const getTimeAgo = (date) => {
        const diff = Math.floor((Date.now() - new Date(date)) / 1000);

        if (diff < 5) return "just now";
        if (diff < 60) return `${diff}s ago`;
        if (diff < 3600) return `${Math.floor(diff / 60)}m ago`;
        if (diff < 86400) return `${Math.floor(diff / 3600)}h ago`;

        return `${Math.floor(diff / 86400)}d ago`;
    };

    const ActivityLogs = ({ logs = [] }) => {
        const activityLogs = Array.isArray(logs) ? logs.slice().reverse() : []
        if (activityLogs.length === 0) {
            return (
                <div style={{ color: '#6B7280', fontSize: '13px', padding: '14px 4px' }}>
                    No Logs Available Yet.
                </div>
            )
        }

        return (
            <div>
                {activityLogs.map((log, index) => {
                    const [title, change] = (log.Description || '').split("|")
                    const logDate = log.CreatedDate ? new Date(log.CreatedDate) : null
                    const logDateLabel = logDate && !Number.isNaN(logDate.getTime()) ? logDate.toLocaleString() : ''

                    return (
                        <div
                            key={log.Id || index}
                            style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-between",
                                padding: "14px 0",
                                borderBottom: "1px solid #D5D4D4",
                            }}
                        >
                            {/* LEFT SIDE */}
                            <div
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "12px",
                                }}
                            >
                                {/* Avatar */}
                                <div
                                    style={{
                                        width: "36px",
                                        height: "36px",
                                        borderRadius: "50%",
                                        backgroundColor: "#EAF4FF",
                                        color: "#1A76D3",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        fontWeight: "600",
                                        fontSize: "14px",
                                    }}
                                >
                                    {log.CreatedBy?.charAt(0)?.toUpperCase()}
                                </div>

                                {/* Text */}
                                <div style={{ display: "flex", flexDirection: "column", gap: "4px" }}>
                                    <div style={{ fontSize: "14px", display: "flex", gap: "6px", flexWrap: "wrap" }}>
                                        <span style={{ color: "var(--ui-text-primary, #ffffff)" }}>
                                            {log.CreatedBy}
                                        </span>
                                        <span style={{ color: "#aaa" }}>{title}</span>
                                        {change && (
                                            <span style={{ color: "#aaa" }}>
                                                {change.split("→")[0]} To {change.split("→")[1]}
                                            </span>
                                        )}
                                    </div>
                                    {logDateLabel && (
                                        <div style={{ fontSize: "12px", color: "#777", lineHeight: 1.4 }}>
                                            {logDateLabel}
                                        </div>
                                    )}
                                </div>
                            </div>

                            <div
                                style={{
                                    fontSize: "12px",
                                    color: "#777",
                                    whiteSpace: "nowrap",
                                }}
                            >
                                {getTimeAgo(log.CreatedDate)}
                            </div>
                        </div>
                    )
                })}
            </div>
        )
    }

    const [loggedInUsername, setLoggedInUsername] = useState('')
    const [loggedInUserId, setLoggedInUserId] = useState('')

    const [task, setTask] = useState({
        Id: Date.now(),
        Title: '',
        StatusId: null,
        Status: 'To Do',
        DueDate: null,
        reminderDate: null,
        Summary: '',
        Type: 'Story',
        Priority: 'Low',
        Tags: [],
        comments: [],
        Assignee: null,
        files: [],
        subtask: [],
        Assigner: null,
        activities: [],
        isArchived: false,
    });
    useEffect(() => {
        if (!task.DueDate) return;

        setTask((prev) => {
            const previousDefaultReminder = computeReminderDate(prev.DueDate)
            const nextDefaultReminder = computeReminderDate(task.DueDate)
            const shouldAutoUpdateReminder = !prev.reminderDate || prev.reminderDate === previousDefaultReminder
            if (!shouldAutoUpdateReminder || prev.reminderDate === nextDefaultReminder) {
                return prev;
            }

            return {
                ...prev,
                reminderDate: nextDefaultReminder,
            }
        })
    }, [task.DueDate]);

    const resetTaskState = () => {
        const templateDefaults = getTaskTemplateDefaults(taskTemplateType)
        const normalizedColumns = normalizeKanbanColumns(boardData?.columns || [])
        const firstEditableColumn = normalizedColumns.find(
            (column) => !isArchivedColumnLabel(column?.headerText),
        )
        const defaultStatusColumn =
            firstEditableColumn ||
            findKanbanStatusColumn(boardData?.columns) ||
            null
        setTitle('')
        setDescription(templateDefaults.description)
        setComment('')
        setCommentEditId(null)
        setSelectLabs([])
        setSelectMeds([])
        setSelectImaging([])
        setSelectedAssignee(templateDefaults.assignees)
        setTextInput('')
        setNewSubtaskTitle('')
        setShowNewSubtaskInput(false)
        setTask({
            Id: `${Date.now()}`,
            Title: '',
            StatusId: defaultStatusColumn?.keyField || '',
            Status: defaultStatusColumn?.headerText || 'To Do',
            DueDate: templateDefaults.dueDate,
            reminderDate: templateDefaults.reminderDate,
            Summary: "",
            Type: 'Story',
            Priority: templateDefaults.priority,
            Tags: [],
            comments: [],
            Assignee: templateDefaults.assignees,
            Color: '#02897B',
            files: [],
            subtask: normalizeSubtaskList(templateDefaults.subtasks).map((subtask) => ({
                ...subtask,
                createdBy: subtask.createdBy || loggedInUserId,
            })),
            Assigner: loggedInUserId ? { value: loggedInUserId, label: loggedInUsername } : '',
            activities: [],
            ClassName: 'e-story, e-low,',
            isArchived: false,
        })
    }

    const sectionCardStyle = {
        background: 'transparent',
        border: '0',
        borderRadius: '0',
        padding: '0',
        boxShadow: 'none',
    }

    const sectionSubtitleStyle = {
        fontSize: '12px',
        fontWeight: 600,
        letterSpacing: '0.04em',
        textTransform: 'uppercase',
        color: '#6B778C',
        marginBottom: '8px',
    }

    const getStatusColors = (label = '') => {
        const normalized = String(label).toLowerCase()
        if (normalized.includes('done')) return { background: '#DCFCE7', color: '#166534', border: '#86EFAC' }
        if (normalized.includes('review')) return { background: '#E0E7FF', color: '#3730A3', border: '#A5B4FC' }
        if (normalized.includes('progress')) return { background: '#DBEAFE', color: '#1D4ED8', border: '#93C5FD' }
        if (normalized.includes('todo') || normalized.includes('to do')) return { background: '#E2E8F0', color: '#1E3A8A', border: '#CBD5E1' }
        return { background: '#F3F4F6', color: '#111827', border: '#D1D5DB' }
    }

    const cleanDate = (value) => {
        return formatValueToISODate(value)
    }

    const isOverdueDate = (value) => {
        const due = cleanDate(value)
        if (!due) return false
        const today = new Date().toISOString().slice(0, 10)
        return due < today
    }

    const isStatusCompleted = (status, statusId = null) => {
        if (status === true) return true
        const normalized = String(status || '').trim().toLowerCase()
        if (normalized === 'done' || normalized === 'completed' || normalized.includes('done') || normalized.includes('completed')) {
            return true
        }
        if (statusId) {
            const statusOption = statusOptions.find((option) => String(option.value) === String(statusId))
            const optionLabel = String(statusOption?.label || '').trim().toLowerCase()
            if (optionLabel === 'done' || optionLabel === 'completed' || optionLabel.includes('done') || optionLabel.includes('completed')) {
                return true
            }
        }
        return false
    }

    const isOverdueAndNotComplete = (value, status, statusId, parentStatus, parentStatusId) => {
        return isOverdueDate(value) && !isStatusCompleted(status, statusId) && !isStatusCompleted(parentStatus, parentStatusId)
    }

    const jiraSelectStyles = {
        control: (base, state) => ({
            ...base,
            minHeight: 42,
            borderRadius: 12,
            border: '1px solid var(--ui-dashboard-border-strong)',
            boxShadow: 'none',
            '&:hover': {
                borderColor: 'var(--ui-color-primary)',
            },
            background: 'var(--ui-dashboard-bg)',
        }),
        valueContainer: (base) => ({
            ...base,
            padding: '4px 12px',
            display: 'flex',
            flexWrap: 'wrap',
            gap: '6px',
            overflow: 'hidden',
        }),
        placeholder: (base) => ({
            ...base,
            color: '#6B778C',
            fontSize: '11px',
        }),
        multiValue: (base) => ({
            ...base,
            borderRadius: 4,
            background: 'var(--ui-dashboard-surface-2)',
            margin: '0 6px 0 0',
            padding: '3px 7px',
            fontWeight: 500,
            fontSize: '12px',
            color: 'var(--ui-text-primary)',
            display: 'inline-flex',
            alignItems: 'center',
            maxHeight: '28px',
        }),
        multiValueLabel: (base) => ({
            ...base,
            padding: 0,
            whiteSpace: 'nowrap',
            fontSize: '12px',
            fontWeight: 500,
        }),
        multiValueRemove: (base) => ({
            ...base,
            borderRadius: 4,
            padding: '0 4px',
            color: 'var(--ui-text-secondary)',
            fontSize: '12px',
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            ':hover': {
                backgroundColor: 'transparent',
                color: 'var(--ui-text-primary)',
            },
        }),
        singleValue: (base, state) => {
            const colors = getStatusColors(state.data?.label || state.data?.value)
            return {
                ...base,
                margin: 0,
                padding: '4px 10px',
                borderRadius: 12,
                background: colors.background,
                color: colors.color,
                fontWeight: 700,
                fontSize: '11px',
            }
        },
        option: (base, state) => {
            const colors = getStatusColors(state.data?.label || state.data?.value)
            return {
                ...base,
                backgroundColor: state.isSelected ? colors.background : state.isFocused ? 'var(--ui-border-color)' : 'var(--ui-bg-filter)',
                color: colors.color,
                cursor: 'pointer',
                padding: '8px 14px',
                fontSize: '11px',
            }
        },
        menu: (base) => ({
            ...base,
            zIndex: 9999,
            borderRadius: 14,
            overflow: 'hidden',
            backgroundColor: 'var(--ui-bg-filter)',
            boxShadow: 'none',
            border: '1px solid var(--ui-dashboard-border-strong)',
        }),
        menuList: (base) => ({
            ...base,
            backgroundColor: 'var(--ui-bg-filter)',
            color: 'var(--ui-text-primary)',
            padding: '6px 0',
        }),
        dropdownIndicator: (base) => ({
            ...base,
            color: '#6B7280',
        }),
        indicatorSeparator: () => ({ display: 'none' }),
        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
    }

    const headerSelectStyles = {
        control: (base, state) => ({
            ...base,
            minHeight: 42,
            borderRadius: 14,
            border: '1px solid #D3D8E2',
            boxShadow: 'none',
            background: '#F8F9FB',
            '&:hover': {
                borderColor: '#C4CBD6',
            },
            cursor: 'pointer',
        }),
        valueContainer: (base) => ({
            ...base,
            padding: '8px 12px',
            whiteSpace: 'normal',
            overflow: 'visible',
            flexWrap: 'wrap',
        }),
        placeholder: (base) => ({
            ...base,
            color: '#6B778C',
            fontSize: '12px',
            fontWeight: 700,
        }),
        singleValue: (base) => ({
            ...base,
            margin: 0,
            padding: 0,
            color: '#091E42',
            fontWeight: 700,
            fontSize: '12px',
            whiteSpace: 'normal',
            overflow: 'visible',
            textOverflow: 'unset',
        }),
        indicatorsContainer: (base) => ({
            ...base,
            padding: '0 8px',
        }),
        indicatorSeparator: () => ({ display: 'none' }),
        menu: (base) => ({
            ...base,
            zIndex: 9999,
            borderRadius: 14,
            overflow: 'hidden',
            boxShadow: '0 16px 32px rgba(15, 23, 42, 0.12)',
            backgroundColor: 'var(--ui-bg-filter)',
            border: '1px solid var(--ui-dashboard-border-strong)',
        }),
        menuList: (base) => ({
            ...base,
            backgroundColor: 'var(--ui-bg-filter)',
            color: 'var(--ui-text-primary)',
        }),
        option: (base, state) => ({
            ...base,
            backgroundColor: state.isSelected ? 'var(--ui-dashboard-surface-2)' : state.isFocused ? 'var(--ui-border-color)' : 'var(--ui-bg-filter)',
            color: 'var(--ui-text-primary)',
            cursor: 'pointer',
            padding: '10px 14px',
            fontSize: '12px',
            fontWeight: 700,
        }),
        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
    }

    const compactDetailSelectStyles = {
        ...jiraSelectStyles,
        control: (base, state) => ({
            ...jiraSelectStyles.control(base, state),
            minHeight: 28,
            border: state.isFocused ? '1px solid #0C66E4' : '1px solid transparent',
            boxShadow: 'none',
            background: 'transparent',
            borderRadius: 6,
        }),
        valueContainer: (base) => ({
            ...base,
            padding: '4px 8px 4px 6px',
            display: 'flex',
            flexWrap: 'wrap',
            gap: '4px',
            alignItems: 'center',
            minHeight: 'auto',
        }),
        input: (base) => ({
            ...base,
            margin: 0,
            padding: '0 6px 0 0',
            minHeight: '18px',
            lineHeight: '1.2',
        }),
        indicatorSeparator: () => ({ display: 'none' }),
        dropdownIndicator: (base) => ({
            ...base,
            padding: 2,
        }),
        clearIndicator: (base) => ({
            ...base,
            padding: 2,
        }),
        multiValue: (base) => ({
            ...base,
            borderRadius: 4,
            background: 'var(--ui-dashboard-surface-2)',
            margin: '0 6px 0 0',
            padding: '3px 7px',
            fontWeight: 500,
            fontSize: '12px',
            color: 'var(--ui-text-primary)',
            display: 'inline-flex',
            alignItems: 'center',
            maxHeight: '28px',
        }),
        multiValueLabel: (base) => ({
            ...base,
            padding: 0,
            whiteSpace: 'nowrap',
            fontSize: '12px',
            fontWeight: 500,
        }),
        multiValueRemove: (base) => ({
            ...base,
            borderRadius: 4,
            padding: '0 4px',
            color: '#6B7280',
            fontSize: '12px',
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            ':hover': {
                backgroundColor: 'transparent',
                color: 'var(--ui-text-primary)',
            },
        }),
        placeholder: (base) => ({
            ...base,
            fontSize: '12px',
            color: '#6B778C',
        }),
        singleValue: (base) => ({
            ...base,
            margin: 0,
            color: 'var(--ui-text-primary, #172B4D)',
            fontSize: '12px',
            fontWeight: 500,
            lineHeight: 1.4,
        }),
        option: (base, state) => ({
            ...base,
            backgroundColor: state.isSelected ? 'var(--ui-dashboard-surface-2)' : state.isFocused ? 'var(--ui-border-color)' : 'var(--ui-bg-filter)',
            color: 'var(--ui-text-primary)',
            cursor: 'pointer',
            padding: '8px 12px',
            fontSize: '12px',
            fontWeight: 500,
        }),
        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
        menu: (base) => ({
            ...base,
            zIndex: 9999,
            backgroundColor: 'var(--ui-bg-filter)',
            border: '1px solid var(--ui-dashboard-border-strong)',
            borderRadius: 10,
            boxShadow: 'none',
            overflow: 'hidden',
        }),
        menuList: (base) => ({
            ...base,
            backgroundColor: 'var(--ui-bg-filter)',
            color: 'var(--ui-text-primary)',
            padding: '6px 0',
        }),
    }

    const taskTemplateSelectStyles = {
        ...compactDetailSelectStyles,
        control: (base, state) => ({
            ...base,
            minHeight: 32,
            height: 32,
            border: state.isFocused ? '1px solid var(--ui-color-primary)' : '1px solid var(--ui-dashboard-border-strong)',
            borderRadius: 8,
            boxShadow: 'none',
            background: 'var(--ui-dashboard-bg)',
            cursor: 'pointer',
            '&:hover': {
                borderColor: 'var(--ui-color-primary)',
            },
        }),
        valueContainer: (base) => ({
            ...base,
            padding: '4px',
            minHeight: 30,
            display: 'flex',
            alignItems: 'center',
            overflow: 'hidden',
        }),
        singleValue: (base) => ({
            ...base,
            color: 'var(--ui-text-primary, #172B4D)',
            fontSize: '12px',
            fontWeight: 500,
            margin: 0,
        }),
        placeholder: (base) => ({
            ...base,
            color: '#6B778C',
            fontSize: '12px',
            fontWeight: 500,
        }),
        dropdownIndicator: (base) => ({
            ...base,
            color: '#5E6C84',
            padding: '4px',
            '&:hover': {
                color: '#44546F',
            },
        }),
        indicatorsContainer: (base) => ({
            ...base,
            height: 30,
        }),
        option: (base, state) => ({
            ...base,
            backgroundColor: state.isFocused || state.isSelected ? 'var(--ui-border-color)' : 'var(--ui-bg-filter)',
            color: 'var(--ui-text-primary)',
            cursor: 'pointer',
            padding: '4px',
            fontSize: '12px',
            fontWeight: 500,
        }),
        menu: (base) => ({
            ...base,
            zIndex: 9999,
            borderRadius: 8,
            overflow: 'hidden',
            backgroundColor: 'var(--ui-bg-filter)',
            border: '1px solid var(--ui-dashboard-border-strong)',
            boxShadow: 'none',
        }),
        menuList: (base) => ({
            ...base,
            backgroundColor: 'var(--ui-bg-filter)',
            color: 'var(--ui-text-primary)',
            padding: 0,
        }),
    }

    const compactDetailLabelStyle = {
        color: 'var(--ui-text-primary)',
        fontSize: '12px',
        fontWeight: 500,
        paddingTop: '4px',
    }

 

    const descriptionDisplay = description?.trim()
        ? description
        : 'Add a description...'

 

    const toggleSection = (sectionKey) => {
        setCollapsedSections((prev) => ({
            ...prev,
            [sectionKey]: !prev[sectionKey],
        }))
    }

    const getChevronStyle = (isCollapsed) => ({
        transform: isCollapsed ? 'rotate(-90deg)' : 'rotate(0deg)',
        transition: 'transform 0.18s ease',
        cursor: 'pointer',
        flexShrink: 0,
    })

    const subtaskOptions = [
        { value: SUBTASK_STATUS.TODO, label: 'TO DO' },
        { value: SUBTASK_STATUS.IN_PROGRESS, label: 'IN PROGRESS' },
        { value: SUBTASK_STATUS.DONE, label: 'DONE' },
    ]

    const getSubtaskStatusPillStyle = (status) => {
        const normalized = (status || '').toLowerCase()
        if (normalized.includes('progress')) return { background: '#DDEBFF', color: '#1D3A6E' }
        if (normalized.includes('done')) return { background: '#DFF0B8', color: '#216E4E' }
        return { background: 'var(--ui-dashboard-surface-2)', color: 'var(--ui-text-primary)' }
    }

    const getSubtaskStatusPillClassName = (status) => {
        const normalized = (status || '').toLowerCase()
        if (normalized.includes('progress')) return 'task-jira-subtask-status-pill task-jira-subtask-status-pill--progress'
        if (normalized.includes('done')) return 'task-jira-subtask-status-pill task-jira-subtask-status-pill--done'
        return 'task-jira-subtask-status-pill task-jira-subtask-status-pill--todo'
    }

    const completedSubtasks = (task?.subtask || []).filter((item) => item.status === SUBTASK_STATUS.DONE).length
    const totalSubtasks = (task?.subtask || []).length
    const subtaskProgress = totalSubtasks > 0 ? Math.round((completedSubtasks / totalSubtasks) * 100) : 0
    const isTaskDueDateOverdue = isOverdueDate(task?.DueDate)
    const selectPortalTarget = typeof document !== 'undefined' ? document.body : null
    const archivedTextColor = '#475569'
    const archivedStrongTextColor = '#334155'
    const archivedOpacity = 0.9

    const computeReminderDate = (dueDate, offsetDays = 1) => {
        if (!dueDate) return ''
        const date = parseUSDateValue(dueDate)
        if (!date) return ''
        date.setDate(date.getDate() - offsetDays)
        return formatDateToMMDDYYYY(date)
    }

    const addSubtaskRow = (text = '') => {
        const subtaskId = createSubtaskId()

        const newItem = {
            id: subtaskId,
            SubtaskId: subtaskId,
            text,
            status: SUBTASK_STATUS.TODO,
            assignee: [],
            dueDate: '',
            isCompleted: false,
            createdBy: loggedInUsername,
            priority: 'Medium',
        }

        setTask((prev) => {
            const existingSubtasks = Array.isArray(prev.subtask)
                ? prev.subtask
                : []

            return {
                ...prev,
                subtask: [...existingSubtasks, newItem],
            }
        })
    }

    const handleInlineAddSubtask = () => {
        if (!newSubtaskTitle.trim()) return
        console.log('[handleInlineAddSubtask] Adding subtask:', newSubtaskTitle.trim())
        addSubtaskRow(newSubtaskTitle.trim())
        setNewSubtaskTitle('')
        setShowNewSubtaskInput(false)
    }

    const getLoggedUsr = () => {
        try {
            const loggedUsrname = localStorage.getItem('userLoginWithCredentials')
            const storedUser = localStorage.getItem('user')

            if (loggedUsrname) {
                const parsedUser = JSON.parse(loggedUsrname)
                console.log(parsedUser?.phoneNo, 'parsedUser?.phoneNo')
                setLoggedInUsername(parsedUser?.phoneNo || '')
            }

            if (storedUser) {
                const parsedStoredUser = JSON.parse(storedUser)
                setLoggedInUserId(parsedStoredUser?.Id || '')

                console.log(parsedStoredUser, parsedStoredUser?.Id, 'parsedStoredUser')
            }
        } catch (error) {
            console.error('Error parsing logged in user:', error)
        }
    }

    useEffect(() => {
        getLoggedUsr()
    }, [])

    useEffect(() => {
        if (!isCreateMode || !users.length || !loggedInUsername) return
        const defaultUser = users.find(
            (user) => user.label?.toLowerCase().trim() === loggedInUsername?.toLowerCase().trim()
        )

        if (defaultUser) {
            setTask((prev) => ({
                ...prev,
                Assigner: defaultUser,
            }))
        }
    }, [isCreateMode, users, loggedInUsername])


    const handleCloudinaryDelete = (publicId) => {
        setTask((p) => ({
            ...p,
            files: (p.files || []).filter(
                (file) => file.publicId !== publicId
            ),
        }));
    };
    const handleCloudinaryUpload = (url, type, fileName, id, publicId) => {
        setTask(prev => {
            const updatedFiles = [
                ...(prev.files || []),
                { url, type, fileName, id, publicId }
            ];

            return {
                ...prev,
                files: updatedFiles,
                attachmentsJson: updatedFiles, // keep local state only
            };
        });

        console.log(url, type, fileName, id, publicId, 'handleCloudinaryUpload');
    };



    const handleChangeComment = (e) => {
        setComment(e.target.value)
    }

    const handleAddComment = (e) => {
        if (!comment) {

            toast.error('Please enter comment', toastConfig)
            return
        }
        if (commentEditId !== null) {
            const updatedComments = task.comments.map((cmnt) => {
                if (cmnt.id === commentEditId) {
                    return {
                        ...cmnt,
                        text: comment,
                    }
                }
                return cmnt
            })
            setTask({
                ...task,
                comments: updatedComments,
            })
            setComment('')
            setCommentEditId(null)
        } else {
            e.preventDefault()
            if (comment.trim !== '') {
                setTask((p) => ({
                    ...p,
                    comments: [
                        ...(p.comments || []),
                        {
                            id: Date.now(),
                            text: comment,
                            createdAt: new Date(),
                            createdBy: loggedInUsername,
                        },
                    ],
                }))
                setComment('')
            }
        }
    }
    console.log(users, 'users')

    const GetAllUsers = async () => {
        const response = await RegisterUser(
            '',
            '',
            '',
            '',
            'get_all'
        )

        let allUsers = response?.d
        allUsers = allUsers.Users || []

        console.log(allUsers, 'allUsers')

        if (allUsers.length > 0) {
            setUsers(
                allUsers.map((item) => ({
                    UserId: item.Id,
                    Username: item.Username,

                    value: item.Username,

                    label: item.Username,

                    role: 'office',
                }))
            )
        }
    }

    useEffect(() => {
        GetAllUsers()
    }, [])

    const priorityOptions = [
        { value: 'Low', label: 'Low' },
        { value: 'Medium', label: 'Medium' },
        { value: 'High', label: 'High' },
    ]

    const [textInput, setTextInput] = useState('')

    const handleKeyPress = (event) => {
        if (event.key === 'Enter' && textInput.trim()) {
            event.preventDefault()
            const newKeyword = textInput.trim()
            setTask((p) => ({
                ...p,
                Tags: [...p.Tags, newKeyword],
            }))
            //  addActivity(`Updated the tags by ${loggedInUsername}`);
            setTextInput('')

        }
    }

    // Parents Labs,imagigng,medications
    const [imagingTypeList, setImagingTypeList] = useState([])
    const [masterMedications, setMasterMedications] = useState([])
    const [masterLabs, setMasterLabs] = useState([])
    const getImagingData = async () => {
        try {
            const data = await ImagingInformation('GET_ALL')
            if (data) {
                const formattedData = JSON.parse(data.d)?.Data
                const allFormattedData = formattedData
                    .filter((item) => item.Keywords !== '')
                    .map((item) => {
                        return {
                            value: item.ID,
                            label: item.Name
                        }
                    })
                console.log(allFormattedData, 'allFormattedData')
                setImagingTypeList(allFormattedData)
            }
        } catch (error) {
            console.error('Error fetching imaging data', error)
        }
    }

    const GetMasterMedications = async () => {
        try {
            let allMedicines = await MedicineCRUD('GET')
            let formattedData = JSON.parse(allMedicines.d)?.Data
            if (formattedData) {
                formattedData = formattedData.map((item) => {
                    let itemData = JSON.parse(item.Data)
                    return {
                        value: item.ID,
                        label: itemData.name,
                    }
                })
                setMasterMedications(formattedData)
            }
        } catch (error) {
            console.error('Error fetching master medications:', error)
        }
    }


    const getLabData = async () => {
        console.log('labs running')
        try {
            let labData = await LabCRUD("GETALL", "{}");
            labData = JSON.parse(labData.d)?.Data;

            if (labData.length > 0) {
                let option = labData?.map((item) => (
                    {
                        value: item.ID,
                        label: item.LabName,
                    }
                ))
                console.log(option, 'option')
                setMasterLabs(option);
            }
        } catch (error) {
            console.log(error, 'error')
        }
    };
    useEffect(() => {
        getImagingData()
        GetMasterMedications()
        getLabData()
    }, [])

    return (
        <div className="">

            <CModal
                backdrop="static" scrollable size="xl"
                className="task-jira-modal task-modal-pitch-black"
                visible={visible}
                onClose={() => setVisible(false)}
            >
                <CModalHeader closeButton onClose={() => setVisible(false)} style={{ border: '0', padding: '20px 24px 0' }}>
                    <CModalTitle style={{ fontSize: '16px', fontWeight: 600, color: 'var(--ui-text-primary)' }}>
                        {isCreateMode ? 'New Task' : 'Edit Task'}
                    </CModalTitle>
                </CModalHeader>

                <CModalBody style={{ padding: '16px 24px 32px', background: 'var(--ui-bg-modal-body)' }}>
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', gap: '16px', alignItems: 'flex-start', flexWrap: 'nowrap' }}>
                            <div style={{ flex: '1 1 auto', minWidth: 0, maxWidth: 'calc(100% - 220px)' }}>
                                <CFormInput
                                    disabled={Boolean(task?.isArchived) || String(task?.Status || '').trim().toLowerCase() === 'archived'}
                                    value={title}
                                    onChange={(e) => setTitle(e.target.value)}
                                    placeholder="Task Title"
                                    className="task-jira-title-input"
                                    style={{
                                        width: '100%',
                                        minWidth: 0,
                                        border: '0',
                                        background: 'transparent',
                                        fontSize: '28px',
                                        fontWeight: 500,
                                        color: (Boolean(task?.isArchived) || String(task?.Status || '').trim().toLowerCase() === 'archived') ? archivedStrongTextColor : 'var(--ui-text-primary, #172B4D)',
                                        padding: 0,
                                        boxShadow: 'none',
                                        maxWidth: '100%',
                                        opacity: (Boolean(task?.isArchived) || String(task?.Status || '').trim().toLowerCase() === 'archived') ? archivedOpacity : 1,
                                    }}
                                />
                            </div>
                            <div style={{ display: 'flex', gap: '12px', alignItems: 'center', flexWrap: 'wrap' }}>
                                <div className="task-jira-top-status-wrapper">
                                    <Select
                                        isDisabled={Boolean(task?.isArchived) || String(task?.Status || '').trim().toLowerCase() === 'archived'}
                                        className="task-jira-top-status-select"
                                        classNamePrefix="task-status-select"
                                        styles={headerSelectStyles}
                                        placeholder="Select Status"
                                        name="Status"
                                        options={statusOptions}
                                        value={statusOptions.find((option) => String(option.value) === String(task.StatusId)) || null}
                                        menuPortalTarget={selectPortalTarget}
                                        menuPosition="fixed"
                                        onChange={handleStatusChange}
                                    />
                                </div>
                            </div>
                        </div>

                        <div className="task-jira-layout" style={{ columnGap: '20px', rowGap: '18px' }}>
                            <div style={{ display: 'flex', flexDirection: 'column', gap: '16px', minWidth: 0 }}>
                                <div style={{ ...sectionCardStyle, marginBottom: '4px' }}>
                                    <div
                                        onClick={() => toggleSection('description')}
                                        style={{ ...sectionSubtitleStyle, display: 'flex', alignItems: 'center', gap: '8px', marginBottom: collapsedSections.description ? '0' : '10px', cursor: 'pointer', width: 'fit-content' }}
                                    >
                                        <ChevronDown size={14} color="#44546F" style={getChevronStyle(collapsedSections.description)} />
                                        <span style={{ marginBottom: 0, color: 'var(--ui-text-primary, #172B4D)', fontSize: '14px', fontWeight: 600, letterSpacing: 0, textTransform: 'none' }}>Description</span>
                                    </div>

                                    {!collapsedSections.description && (
                                        <div
                                            style={{
                                                border: '1px solid var(--ui-dashboard-border-strong)',
                                                borderRadius: '8px',
                                                overflow: 'hidden',
                                                background: 'var(--ui-dashboard-bg)',
                                                maxWidth: '100%',
                                                minHeight: '110px',
                                                position: 'relative',
                                            }}
                                        >
                                            <CFormTextarea
                                                disabled={Boolean(task?.isArchived) || String(task?.Status || '').trim().toLowerCase() === 'archived'}
                                                value={description || ''}
                                                onChange={(e) => setDescription(e.target.value)}
                                                placeholder="Add Description"
                                                rows={8}
                                                style={{
                                                    width: '100%',
                                                    minHeight: '110px',
                                                    border: '0',
                                                    borderRadius: '8px',
                                                    transition: 'none',
                                                    padding: '14px 16px',
                                                    fontSize: '13px',
                                                    background: 'var(--ui-dashboard-bg)',
                                                    boxShadow: 'none',
                                                    resize: 'none',
                                                    position: 'relative',
                                                    zIndex: 0,
                                                    pointerEvents: (Boolean(task?.isArchived) || String(task?.Status || '').trim().toLowerCase() === 'archived') ? 'none' : 'auto',
                                                    boxSizing: 'border-box',
                                                    opacity: (Boolean(task?.isArchived) || String(task?.Status || '').trim().toLowerCase() === 'archived') ? archivedOpacity : 1,
                                                    color: (Boolean(task?.isArchived) || String(task?.Status || '').trim().toLowerCase() === 'archived') ? archivedStrongTextColor : 'var(--ui-text-primary, #172B4D)',
                                                }}
                                            />
                                        </div>
                                    )}
                                </div>

                                <div style={{ ...sectionCardStyle, marginTop: '8px' }}>
                                    <div style={{ display: 'flex', justifyContent: 'space-between', gap: '12px', alignItems: 'center', marginBottom: '12px', flexWrap: 'wrap' }}>
                                        <div>
                                            <div
                                                onClick={() => toggleSection('subtasks')}
                                                style={{ ...sectionSubtitleStyle, display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '4px', cursor: 'pointer', width: 'fit-content' }}
                                            >
                                                <ChevronDown size={14} color="#44546F" style={getChevronStyle(collapsedSections.subtasks)} />
                                                <span style={{ marginBottom: 0, color: 'var(--ui-text-primary, #172B4D)', fontSize: '14px', fontWeight: 600, letterSpacing: 0, textTransform: 'none' }}>Subtasks</span>
                                            </div>
                                        </div>
                                        <CButton
                                            disabled={Boolean(task?.isArchived) || String(task?.Status || '').trim().toLowerCase() === 'archived'}
                                            size="sm"
                                            className="
    !bg-transparent
    !border-0
    !shadow-none
    !p-0
    !text-[#172B4D]
    transform
    transition-transform
    duration-150
    active:scale-110
    hover:!bg-transparent
    active:!bg-transparent
    focus:!bg-transparent
    focus:!shadow-none
    focus:!outline-none
    focus:!ring-0
  "
                                            style={{
                                                textDecoration: 'none',
                                                fontSize: '28px',
                                                lineHeight: 1,
                                                padding: 0,
                                                color: (Boolean(task?.isArchived) || String(task?.Status || '').trim().toLowerCase() === 'archived') ? archivedTextColor : 'var(--ui-text-primary, #172B4D)',
                                                backgroundColor: 'transparent',
                                                border: 'none',
                                                boxShadow: 'none',
                                                outline: 'none',
                                                transform: (Boolean(task?.isArchived) || String(task?.Status || '').trim().toLowerCase() === 'archived') ? 'scale(0.9)' : (plusHover ? 'scale(1.12)' : 'scale(1)'),
                                                transition: 'transform 150ms ease',
                                                opacity: (Boolean(task?.isArchived) || String(task?.Status || '').trim().toLowerCase() === 'archived') ? 0.5 : 1,
                                                cursor: (Boolean(task?.isArchived) || String(task?.Status || '').trim().toLowerCase() === 'archived') ? 'not-allowed' : 'pointer',
                                            }}
                                            onMouseEnter={() => !Boolean(task?.isArchived) && setPlusHover(true)}
                                            onMouseLeave={() => setPlusHover(false)}
                                            onClick={() => {
                                                if (!(Boolean(task?.isArchived) || String(task?.Status || '').trim().toLowerCase() === 'archived')) {
                                                    setCollapsedSections((prev) => ({ ...prev, subtasks: false }))
                                                    setShowNewSubtaskInput(true)
                                                }
                                            }}
                                        >
                                            +
                                        </CButton>
                                    </div>

                                    {!collapsedSections.subtasks && (
                                        <div className="task-jira-subtask-progress" style={{ marginBottom: '12px' }}>
                                            <div className="task-jira-subtask-progress-row" style={{ display: 'flex', alignItems: 'center', gap: '0px' }}>
                                                <div className="task-jira-subtask-progress-bar" style={{ flex: 1, height: '10px', borderRadius: '999px', background: 'var(--ui-border-strong)', overflow: 'hidden' }}>
                                                    <div style={{ width: `${subtaskProgress}%`, height: '100%', background: subtaskProgress === 100 ? 'rgb(60 173 19)' : 'var(--ui-dashboard-border-strong)', borderRadius: '999px' }} />
                                                </div>
                                                <div className="task-jira-subtask-progress-label" style={{ fontSize: '12px', color: subtaskProgress === 100 ? 'rgb(60 173 19)' : '#5E6C84', minWidth: '78px', textAlign: 'right' }}>
                                                    {subtaskProgress}% Done
                                                </div>
                                            </div>
                                        </div>
                                    )}

                                    {!collapsedSections.subtasks && <div className="task-jira-subtask-table-wrap">
                                        <div className="task-jira-subtask-table-head">
                                            <div style={{ padding: '10px 12px' }}>Work</div>
                                            <div style={{ padding: '10px 10px' }}>Due Date</div>
                                            <div style={{ padding: '10px 10px' }}>Assigned To</div>
                                            <div style={{ padding: '10px 12px' }}>Status</div>
                                        </div>

                                        <div className="task-jira-subtask-table-body">
                                            {(task?.subtask || []).map((item, idx) => (
                                                <div
                                                    key={item.id || item.SubtaskId || idx}
                                                    className="task-jira-subtask-table-row"
                                                >
                                                    <div style={{ padding: '10px 12px', display: 'flex', alignItems: 'center', gap: '10px', minWidth: 0 }}>
                                                        <CFormCheck
                                                            disabled={Boolean(task?.isArchived) || String(task?.Status || '').trim().toLowerCase() === 'archived'}
                                                            checked={item.status === SUBTASK_STATUS.DONE}
                                                            onChange={() => {
                                                                const newStatus =
                                                                    item.status === SUBTASK_STATUS.DONE
                                                                        ? SUBTASK_STATUS.TODO
                                                                        : SUBTASK_STATUS.DONE

                                                                setTask((prev) => ({
                                                                    ...prev,
                                                                    subtask: prev.subtask.map((s, subtaskIndex) =>
                                                                        subtaskIndex === idx
                                                                            ? {
                                                                                ...s,
                                                                                status: newStatus,
                                                                                isCompleted: newStatus === SUBTASK_STATUS.DONE,
                                                                                checkedBy: loggedInUsername || ''
                                                                            }
                                                                            : s
                                                                    ),
                                                                }))
                                                            }}
                                                            style={{ marginTop: '1px' }}


                                                        />
                                                        {/* <div style={{ color: '#4C7FF0', fontSize: '14px', flexShrink: 0 }}>◫</div> */}
                                                        <CFormInput
                                                            disabled={Boolean(task?.isArchived) || String(task?.Status || '').trim().toLowerCase() === 'archived'}
                                                            value={item.text}
                                                            style={{
                                                                textDecoration: item.isCompleted ? 'line-through' : 'none',
                                                                opacity: item.isCompleted ? 0.6 : (Boolean(task?.isArchived) || String(task?.Status || '').trim().toLowerCase() === 'archived') ? archivedOpacity : 1,
                                                                border: '0',
                                                                boxShadow: 'none',
                                                                padding: 0,
                                                                fontSize: '12px',
                                                                color: (Boolean(task?.isArchived) || String(task?.Status || '').trim().toLowerCase() === 'archived') ? archivedStrongTextColor : 'var(--ui-text-primary, #172B4D)',
                                                                background: 'transparent',
                                                                cursor: (Boolean(task?.isArchived) || String(task?.Status || '').trim().toLowerCase() === 'archived') ? 'default' : 'text',
                                                            }}
                                                            placeholder="Name the Subtask"
                                                            onChange={(e) => {
                                                                const value = e.target.value
                                                                setTask((p) => ({
                                                                    ...p,
                                                                    subtask: p.subtask.map((s, subtaskIndex) =>
                                                                        subtaskIndex === idx
                                                                            ? { ...s, text: value }
                                                                            : s
                                                                    ),
                                                                }))
                                                            }}
                                                        />
                                                    </div>

                                                    <div style={{ padding: '10px', display: 'flex', alignItems: 'center', height: 'auto' }}>
                                                        <CustomDatePickingFormat
                                                            className={`task-jira-date-input${isOverdueAndNotComplete(item.dueDate, item.isCompleted || item.status, task.Status) ? ' task-jira-date-input-overdue' : ''}`}
                                                            disabled={Boolean(task?.isArchived) || String(task?.Status || '').trim().toLowerCase() === 'archived'}
                                                            value={item.dueDate || ''}
                                                            onChange={(value) => {
                                                                setTask((prev) => ({
                                                                    ...prev,
                                                                    subtask: prev.subtask.map((s, subtaskIndex) =>
                                                                        subtaskIndex === idx
                                                                            ? { ...s, dueDate: value }
                                                                            : s
                                                                    ),
                                                                }))
                                                            }}
                                                            inputStyle={{
                                                                minHeight: 30,
                                                                border: '0',
                                                                boxShadow: 'none',
                                                                padding: '0 28px 0 2px',
                                                                fontSize: '12px',
                                                                color: isOverdueAndNotComplete(item.dueDate, item.isCompleted || item.status, task.Status) ? 'rgb(154 18 18)' : (Boolean(task?.isArchived) || String(task?.Status || '').trim().toLowerCase() === 'archived') ? archivedStrongTextColor : 'var(--ui-text-primary, #172B4D)',
                                                                background: 'transparent',
                                                                opacity: (Boolean(task?.isArchived) || String(task?.Status || '').trim().toLowerCase() === 'archived') ? archivedOpacity : 1,
                                                            }}
                                                        />
                                                    </div>

                                                    <div className="task-jira-subtask-assignee-wrapper" style={{ width: '100%', maxWidth: '100%', padding: '10px', overflow: 'visible', whiteSpace: 'normal', height: 'auto', boxSizing: 'border-box', display: 'flex', alignItems: 'center', msOverflowStyle: 'auto', scrollbarWidth: 'thin', minHeight: '40px', borderRight: '0' }}>
                                                        <Select
                                                            isDisabled={Boolean(task?.isArchived) || String(task?.Status || '').trim().toLowerCase() === 'archived'}
                                                            className="task-jira-subtask-assignee-select"
                                                            classNamePrefix="subtask-assignee-select"
                                                            styles={{
                                                                ...jiraSelectStyles,
                                                                control: (base, state) => ({
                                                                    ...jiraSelectStyles.control(base, state),
                                                                    minHeight: 30,
                                                                    border: '0',
                                                                    outline: 'none',
                                                                    boxShadow: 'none',
                                                                    background: 'transparent',
                                                                    width: '100%',
                                                                    height: 'auto',
                                                                    alignItems: 'center',
                                                                    opacity: (Boolean(task?.isArchived) || String(task?.Status || '').trim().toLowerCase() === 'archived') ? archivedOpacity : 1,
                                                                }),
                                                                valueContainer: (base) => ({
                                                                    ...base,
                                                                    padding: '0',
                                                                    display: 'flex',
                                                                    flexDirection: 'column',
                                                                    alignItems: 'flex-start',
                                                                    flexWrap: 'nowrap',
                                                                    gap: '4px',
                                                                    overflowX: 'hidden',
                                                                    overflowY: 'auto',
                                                                    maxHeight: '30px',
                                                                    scrollbarWidth: 'thin',
                                                                }),
                                                                multiValue: (base) => ({
                                                                    ...base,
                                                                    display: 'flex',
                                                                    width: 'fit-content',
                                                                    minWidth: 0,
                                                                    maxWidth: '100%',
                                                                    backgroundColor: 'hsl(0, 0%, 90%)',
                                                                    borderRadius: 4,
                                                                    margin: 0,
                                                                    boxSizing: 'border-box',
                                                                    flexShrink: 0,
                                                                    fontWeight: 600,
                                                                    fontSize: '12px',
                                                                    padding: '4px 7px',
                                                                    color: 'var(--ui-text-primary, #172B4D)',
                                                                    alignItems: 'center',
                                                                    maxHeight: '28px',
                                                                }),
                                                                multiValueLabel: (base) => ({
                                                                    ...base,
                                                                    whiteSpace: 'nowrap',
                                                                    padding: 0,
                                                                    overflow: 'hidden',
                                                                    textOverflow: 'ellipsis',
                                                                    flex: 1,
                                                                    fontSize: '12px',
                                                                }),
                                                                multiValueRemove: (base) => ({
                                                                    ...base,
                                                                    display: 'flex',
                                                                    alignItems: 'center',
                                                                    justifyContent: 'center',
                                                                    borderRadius: '50%',
                                                                    paddingLeft: '4px',
                                                                    paddingRight: '4px',
                                                                    boxSizing: 'border-box',
                                                                    width: '18px',
                                                                    height: '18px',
                                                                    marginLeft: '6px',
                                                                    ':hover': {
                                                                        backgroundColor: 'transparent',
                                                                        color: base.color,
                                                                    },
                                                                }),
                                                                input: (base) => ({
                                                                    ...base,
                                                                    margin: 0,
                                                                    padding: 0,
                                                                }),
                                                                placeholder: (base) => ({
                                                                    ...base,
                                                                    whiteSpace: 'nowrap',
                                                                }),
                                                                indicatorSeparator: () => ({ display: 'none' }),
                                                                clearIndicator: () => ({ display: 'none' }),
                                                                dropdownIndicator: (base) => ({
                                                                    ...base,
                                                                    padding: 2,
                                                                }),
                                                                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                                                menu: (base) => ({ ...base, zIndex: 9999 }),
                                                            }}
                                                            menuPortalTarget={selectPortalTarget}
                                                            menuPosition="fixed"
                                                            isMulti
                                                            isClearable={false}
                                                            closeMenuOnSelect={false}
                                                            hideSelectedOptions
                                                            getOptionValue={getAssigneeOptionValue}
                                                            value={normalizeSubtaskAssignees(item.assignee)}
                                                            options={users}
                                                            placeholder="Unassigned"
                                                            onChange={(selectedOptions) => {
                                                                setTask((prev) => ({
                                                                    ...prev,
                                                                    subtask: prev.subtask.map((s, subtaskIndex) =>
                                                                        subtaskIndex === idx
                                                                            ? { ...s, assignee: selectedOptions || [] }
                                                                            : s
                                                                    ),
                                                                }))
                                                            }}
                                                        />
                                                    </div>

                                                    <div className="task-jira-subtask-status-wrapper" style={{ width: '100%', maxWidth: '100%', padding: '6px 10px', borderLeft: '1px solid #E5E7EB', display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '8px', overflow: 'visible', position: 'relative', zIndex: 2, height: '100%' }}>
                                                        <Select
                                                            isDisabled={Boolean(task?.isArchived) || String(task?.Status || '').trim().toLowerCase() === 'archived'}
                                                            className="task-jira-subtask-status-select"
                                                            classNamePrefix="subtask-status-select"
                                                            styles={{
                                                                ...jiraSelectStyles,
                                                                control: (base, state) => ({
                                                                    ...jiraSelectStyles.control(base, state),
                                                                    minHeight: 30,
                                                                    border: '0',
                                                                    outline: 'none',
                                                                    boxShadow: 'none',
                                                                    background: 'transparent',
                                                                    opacity: (Boolean(task?.isArchived) || String(task?.Status || '').trim().toLowerCase() === 'archived') ? archivedOpacity : 1,
                                                                }),
                                                                valueContainer: (base) => ({
                                                                    ...base,
                                                                    padding: '0 4px',
                                                                }),
                                                                indicatorSeparator: () => ({ display: 'none' }),
                                                                dropdownIndicator: (base) => ({
                                                                    ...base,
                                                                    padding: 2,
                                                                }),
                                                                singleValue: (base) => ({
                                                                    ...base,
                                                                    margin: 0,
                                                                }),
                                                                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                                                menu: (base) => ({ ...base, zIndex: 9999 }),
                                                            }}
                                                            menuPortalTarget={selectPortalTarget}
                                                            menuPosition="fixed"
                                                            value={{
                                                                value: item.status || SUBTASK_STATUS.TODO,
                                                                label: item.status || 'TO DO',
                                                            }}
                                                            options={subtaskOptions}
                                                            formatOptionLabel={(option) => (
                                                                <span className={getSubtaskStatusPillClassName(option.value)} style={{ ...getSubtaskStatusPillStyle(option.value), borderRadius: '4px', padding: '3px 8px', fontSize: '11px', fontWeight: 700, display: 'inline-block' }}>
                                                                    {option.label}
                                                                </span>
                                                            )}
                                                            onChange={(option) => {
                                                                const newStatus = option.value

                                                                setTask((prev) => ({
                                                                    ...prev,
                                                                    subtask: prev.subtask.map((s, subtaskIndex) =>
                                                                        subtaskIndex === idx
                                                                            ? {
                                                                                ...s,
                                                                                status: newStatus,
                                                                                isCompleted: newStatus === SUBTASK_STATUS.DONE,
                                                                                checkedBy: loggedInUsername || ''
                                                                            }
                                                                            : s
                                                                    ),
                                                                }))
                                                            }}
                                                        />

                                                        <CDropdown alignment="end" className="task-jira-subtask-actions">
                                                            <CDropdownToggle
                                                                className="task-jira-subtask-action-toggle"
                                                                variant="ghost"
                                                                style={{
                                                                    padding: '2px 5px',
                                                                    borderRadius: '6px',
                                                                    background: 'transparent',
                                                                    border: '0',
                                                                    color: '#44546F',
                                                                }}
                                                            >
                                                                <EllipsisVertical size={16} color="#44546F" />
                                                            </CDropdownToggle>
                                                            <CDropdownMenu className="task-jira-subtask-action-menu">
                                                                <CDropdownItem
                                                                    onClick={() => {
                                                                        const today = new Date().toISOString().slice(0, 10)
                                                                        setTask((prev) => ({
                                                                            ...prev,
                                                                            subtask: prev.subtask.map((subtask, subtaskIndex) =>
                                                                                subtaskIndex === idx
                                                                                    ? { ...subtask, dueDate: subtask.dueDate || today }
                                                                                    : subtask
                                                                            ),
                                                                        }))
                                                                    }}
                                                                >
                                                                    Add Reminder
                                                                </CDropdownItem>

                                                                {item.isCompleted && <CDropdownItem>Completed By: {item.checkedBy}</CDropdownItem>}
                                                                <CDropdownItem
                                                                    style={{ color: 'rgb(154 18 18)' }}
                                                                    onClick={() => handleDeleteSubtaskRequest(idx)}
                                                                >
                                                                    Delete
                                                                </CDropdownItem>
                                                            </CDropdownMenu>
                                                        </CDropdown>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    </div>}

                                    {!collapsedSections.subtasks && showNewSubtaskInput && (
                                        <div style={{ marginTop: '14px' }}>
                                            <div style={{ border: '1px solid rgb(133, 184, 255)', borderRadius: '8px', padding: '0px 5px', minHeight: '42px', display: 'flex', alignItems: 'center', gap: '12px' }}>
                                                <input
                                                    value={newSubtaskTitle}
                                                    onChange={(e) => setNewSubtaskTitle(e.target.value)}
                                                    onKeyDown={(e) => {
                                                        if (e.key === 'Enter') {
                                                            e.preventDefault()
                                                            handleInlineAddSubtask()
                                                        }
                                                    }}
                                                    placeholder="Name the Subtask"
                                                    className="task-jira-inline-subtask-input"
                                                    style={{
                                                        flex: 1,
                                                        border: 0,
                                                        outline: 'none',
                                                        fontSize: '12px',
                                                        color: 'var(--ui-text-primary, #172B4D)',
                                                        background: 'transparent',
                                                    }}
                                                />
                                                <button
                                                    type="button"
                                                    onClick={handleInlineAddSubtask}
                                                    disabled={!newSubtaskTitle.trim()}
                                                    style={{
                                                        border: '0px',
                                                        borderRadius: '6px',
                                                        background: newSubtaskTitle.trim() ? 'rgb(12, 102, 228)' : '#CBD5E1',
                                                        color: 'rgb(255, 255, 255)',
                                                        fontSize: '12px',
                                                        fontWeight: 600,
                                                        padding: '6px 12px',
                                                        cursor: newSubtaskTitle.trim() ? 'pointer' : 'not-allowed',
                                                        opacity: newSubtaskTitle.trim() ? 1 : 0.6,
                                                    }}
                                                >
                                                    Add
                                                </button>
                                            </div>
                                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', gap: '14px', marginTop: '12px', padding: '0 4px' }}>
                                                <button
                                                    type="button"
                                                    className="task-jira-inline-subtask-cancel"
                                                    onClick={() => {
                                                        setNewSubtaskTitle('')
                                                        setShowNewSubtaskInput(false)
                                                    }}
                                                    style={{
                                                        border: 0,
                                                        background: 'transparent',
                                                        color: '#44546F',
                                                        fontSize: '12px',
                                                        fontWeight: 500,
                                                        padding: 0,
                                                    }}
                                                >
                                                    Cancel
                                                </button>
                                            </div>
                                        </div>
                                    )}
                                </div>

                                {showPatientDetailsSection && <div style={{ ...sectionCardStyle, marginTop: '12px', marginBottom: '16px' }}>
                                    <div style={{ display: 'flex', justifyContent: 'space-between', gap: '12px', marginBottom: collapsedSections.patientDetails ? '0' : '14px', alignItems: 'center', flexWrap: 'wrap' }}>
                                        <div
                                            onClick={() => toggleSection('patientDetails')}
                                            style={{ ...sectionSubtitleStyle, display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer', width: 'fit-content' }}
                                        >
                                            <ChevronDown size={14} color="#44546F" style={getChevronStyle(collapsedSections.patientDetails)} />
                                            <span style={{ marginBottom: 0, color: 'var(--ui-text-primary, #172B4D)', fontSize: '14px', fontWeight: 600, letterSpacing: 0, textTransform: 'none' }}>Patient Details</span>
                                        </div>
                                    </div>

                                    {!collapsedSections.patientDetails && (
                                        <div style={{ display: 'grid', gap: '18px', paddingBottom: '12px' }}>
                                            <div style={{ marginBottom: '6px' }}>
                                                <CFormLabel>Select Labs</CFormLabel>
                                                <Select
                                                    isDisabled={Boolean(task?.isArchived) || String(task?.Status || '').trim().toLowerCase() === 'archived'}
                                                    styles={jiraSelectStyles}
                                                    classNamePrefix="detail-select"
                                                    placeholder="Select Labs"
                                                    name="Status"
                                                    isMulti
                                                    closeMenuOnSelect={false}
                                                    onChange={setSelectLabs}
                                                    value={selectLabs}
                                                    options={masterLabs}
                                                />
                                            </div>
                                            <div style={{ marginBottom: '6px' }}>
                                                <CFormLabel>Select Medications</CFormLabel>
                                                <Select
                                                    isDisabled={Boolean(task?.isArchived) || String(task?.Status || '').trim().toLowerCase() === 'archived'}
                                                    styles={jiraSelectStyles}
                                                    classNamePrefix="detail-select"
                                                    placeholder="Select Medications"
                                                    name="Status"
                                                    isMulti
                                                    closeMenuOnSelect={false}
                                                    onChange={setSelectMeds}
                                                    value={selectMeds}
                                                    options={masterMedications}
                                                />
                                            </div>
                                            <div style={{ marginBottom: '6px' }}>
                                                <CFormLabel>Select Imagings</CFormLabel>
                                                <Select
                                                    isDisabled={Boolean(task?.isArchived) || String(task?.Status || '').trim().toLowerCase() === 'archived'}
                                                    styles={jiraSelectStyles}
                                                    classNamePrefix="detail-select"
                                                    placeholder="Select Imagings"
                                                    name="Status"
                                                    isMulti
                                                    closeMenuOnSelect={false}
                                                    onChange={setSelectImaging}
                                                    value={selectImaging}
                                                    options={imagingTypeList}
                                                />
                                            </div>
                                        </div>
                                    )}
                                </div>}

                                <div style={{ ...sectionCardStyle, marginTop: '16px' }}>
                                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '16px' }}>
                                        <Paperclip size={18} color="#44546F" />
                                        <h3 style={{ margin: 0, fontSize: '14px', fontWeight: 600, color: 'var(--ui-text-primary, #172B4D)' }}>Attachments</h3>
                                    </div>
                                    <div style={{
                                        opacity: (Boolean(task?.isArchived) || String(task?.Status || '').trim().toLowerCase() === 'archived') ? 0.5 : 1,
                                        pointerEvents: (Boolean(task?.isArchived) || String(task?.Status || '').trim().toLowerCase() === 'archived') ? 'none' : 'auto',
                                        cursor: (Boolean(task?.isArchived) || String(task?.Status || '').trim().toLowerCase() === 'archived') ? 'not-allowed' : 'pointer'
                                    }}>
                                        <CloudinaryUploader acceptedFileTypes='image/*,' filesAl={task?.files} onDelete={handleCloudinaryDelete} onUploadSuccess={handleCloudinaryUpload} isFromTaskMgmt={true} />
                                    </div>
                                    <div style={{ display: 'flex', marginTop: '16px', alignItems: 'center', gap: '12px', flexWrap: 'wrap' }}>
                                        {Array.isArray(task.files) && task.files.length > 0 &&
                                            task.files.map((file, idx) => (
                                                <div key={idx} className="d-flex flex-column align-items-center">
                                                    <img
                                                        src={file.url}
                                                        alt={file.fileName || 'Preview'}
                                                        onClick={() => window.open(file.url, '_blank', 'noopener,noreferrer')}
                                                        style={{
                                                            width: '92px',
                                                            height: '92px',
                                                            borderRadius: '8px',
                                                            objectFit: 'cover',
                                                            border: '1px solid #DFE1E6',
                                                            cursor: 'pointer',
                                                        }}
                                                    />
                                                </div>
                                            ))}
                                    </div>
                                </div>

                                <div style={{ ...sectionCardStyle, marginTop: '18px' }}>
                                    <div
                                        onClick={() => toggleSection('activity')}
                                        style={{ ...sectionSubtitleStyle, display: 'flex', alignItems: 'center', gap: '8px', marginBottom: collapsedSections.activity ? '0' : '12px', cursor: 'pointer', width: 'fit-content' }}
                                    >
                                        <ChevronDown size={14} color="#44546F" style={getChevronStyle(collapsedSections.activity)} />
                                        <span style={{ marginBottom: 0, color: 'var(--ui-text-primary, #172B4D)', fontSize: '14px', fontWeight: 600, letterSpacing: 0, textTransform: 'none' }}>Activity</span>
                                    </div>

                                    {!collapsedSections.activity && (
                                        <>
                                            <CNav role="tablist" activeKey={activeKey} style={{ display: 'flex', gap: '8px', marginBottom: '16px' }}>
                                                {[
                                                    { key: 1, label: 'Comments' },
                                                    { key: 2, label: 'Logs' },
                                                ].map((tab) => {
                                                    const tabIsActive = activeKey === tab.key
                                                    return (
                                                        <CNavItem key={tab.key}>
                                                            <CNavLink
                                                                onClick={() => setActiveKey(tab.key)}
                                                                style={{
                                                                    fontSize: '13px',
                                                                    padding: '7px 14px',
                                                                    borderRadius: '8px',
                                                                    cursor: 'pointer',
                                                                    backgroundColor: tabIsActive ? 'var(--ui-color-primary)' : 'var(--ui-dashboard-surface)',
                                                                    color: tabIsActive ? 'var(--ui-text-inverse)' : 'var(--ui-text-secondary)',
                                                                    border: tabIsActive ? '1px solid var(--ui-color-primary)' : '1px solid var(--task-jira-modal-border, var(--ui-dashboard-border-strong))',
                                                                    fontWeight: 600,
                                                                }}
                                                            >
                                                                {tab.label}
                                                            </CNavLink>
                                                        </CNavItem>
                                                    )
                                                })}
                                            </CNav>

                                            {activeKey === 1 && (
                                                <div className="d-flex gap-3 flex-column">
                                                    <div className="d-flex flex-column align-items-start gap-2">
                                                        <CFormLabel>Add Comment</CFormLabel>
                                                        <CFormTextarea disabled={Boolean(task?.isArchived) || String(task?.Status || '').trim().toLowerCase() === 'archived'} aria-rowcount={12} style={{ height: '88px', borderRadius: '10px', borderColor: 'var(--ui-dashboard-border-strong)', fontSize: '13px', opacity: (Boolean(task?.isArchived) || String(task?.Status || '').trim().toLowerCase() === 'archived') ? archivedOpacity : 1, pointerEvents: (Boolean(task?.isArchived) || String(task?.Status || '').trim().toLowerCase() === 'archived') ? 'none' : 'auto', color: 'var(--ui-text-primary)', background: 'var(--ui-dashboard-bg)' }} placeholder="Add a Comment..." value={comment} onChange={handleChangeComment} />
                                                        <CButton className='rs_btn-primary' style={{ height: '34px', minHeight: '34px', fontSize:'14px' }} disabled={!comment || Boolean(task?.isArchived) || String(task?.Status || '').trim().toLowerCase() === 'archived'} onClick={handleAddComment}>
                                                            {commentEditId !== null ? 'Edit' : 'Add'}
                                                        </CButton>
                                                    </div>

                                                    <div style={{ marginTop: '4px' }}>
                                                        {task?.comments?.map((item) => (
                                                            <div
                                                                key={item.id}
                                                                style={{
                                                                    display: 'flex',
                                                                    gap: '12px',
                                                                    marginBottom: '16px',
                                                                    paddingBottom: '16px',
                                                                    borderBottom: '1px solid var(--ui-dashboard-border)',
                                                                }}
                                                            >
                                                                <div
                                                                    style={{
                                                                        width: '36px',
                                                                        height: '36px',
                                                                        borderRadius: '50%',
                                                                        backgroundColor: 'var(--ui-dashboard-surface-2)',
                                                                        color: 'var(--ui-color-primary)',
                                                                        display: 'flex',
                                                                        alignItems: 'center',
                                                                        justifyContent: 'center',
                                                                        fontWeight: '600',
                                                                        fontSize: '12px',
                                                                        flexShrink: 0,
                                                                    }}
                                                                >
                                                                    {item.createdBy?.charAt(0)?.toUpperCase()}
                                                                </div>

                                                                <div style={{ flex: 1 }}>
                                                                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '12px', flexWrap: 'wrap' }}>
                                                                        <div style={{ fontSize: '13px', color: 'var(--ui-text-primary, #172B4D)' }}>
                                                                            <strong>{item.createdBy || 'Unknown'}</strong>
                                                                            <span style={{ color: '#6B778C', marginLeft: '8px', fontSize: '12px' }}>
                                                                                {new Date(item.createdAt || Date.now()).toLocaleString()}
                                                                            </span>
                                                                        </div>

                                                                        {loggedInUsername === item.createdBy && (
                                                                            <div style={{ display: 'flex', gap: '8px' }}>
                                                                                <Pencil
                                                                                    size={14}
                                                                                    style={{ cursor: 'pointer', color: '#0C66E4' }}
                                                                                    onClick={() => {
                                                                                        setCommentEditId(item.id);
                                                                                        setComment(item.text);
                                                                                    }}
                                                                                />
                                                                                <Trash
                                                                                    size={14}
                                                                                    style={{ cursor: 'pointer', color: 'rgb(154 18 18)' }}
                                                                                    onClick={() => {
                                                                                        const filtered = task.comments.filter((c) => c.id !== item.id);
                                                                                        setTask((prev) => ({
                                                                                            ...prev,
                                                                                            comments: filtered,
                                                                                        }));
                                                                                    }}
                                                                                />
                                                                            </div>
                                                                        )}
                                                                    </div>

                                                                    <div
                                                                        style={{
                                                                            marginTop: '8px',
                                                                            fontSize: '13px',
                                                                            padding: '9px 11px',
                                                                            borderRadius: '8px',
                                                                            border: '1px solid var(--ui-dashboard-border-strong)',
                                                                            background: 'var(--ui-dashboard-bg)',
                                                                            color: 'var(--ui-text-primary)',
                                                                        }}
                                                                    >
                                                                        {item.text}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        ))}
                                                    </div>
                                                </div>
                                            )}

                                            {activeKey === 2 && <ActivityLogs logs={task.activities} />}
                                        </>
                                    )}
                                </div>
                            </div>

                            <div style={{ display: 'flex', flexDirection: 'column', gap: '16px', minWidth: 0, paddingLeft: '10px' }}>
                                <div style={{ background: 'transparent', border: '0.4px solid var(--ui-border-subtle, #4b5563)', borderRadius: '12px', padding: '12px 15px 15px', boxShadow: 'none' }}>
                                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '12px', marginBottom: '14px' }}>
                                        <div
                                            onClick={() => toggleSection('details')}
                                            style={{ display: 'flex', alignItems: 'center', gap: '10px', cursor: 'pointer', width: 'fit-content' }}
                                        >
                                            <ChevronDown size={16} color="#44546F" style={getChevronStyle(collapsedSections.details)} />
                                            <h3 style={{ margin: 0, fontSize: '16px', fontWeight: 600, color: 'var(--ui-text-primary, #172B4D)' }}>Details</h3>
                                        </div>
                                    </div>

                                    {!collapsedSections.details && (
                                        <div style={{ display: 'grid', gap: '18px', maxWidth: '100%', paddingTop: '0px', margin: '0', width: '100%' }} className="task-details-grid">
                                            {isCreateMode && (
                                                <div style={{ display: 'grid', gridTemplateColumns: '96px minmax(0, 1fr)', gap: '24px', alignItems: 'center' }}>
                                                    <div style={compactDetailLabelStyle}>Task Type</div>
                                                    <Select
                                                        styles={taskTemplateSelectStyles}
                                                        menuPortalTarget={selectPortalTarget}
                                                        menuPosition="fixed"
                                                        classNamePrefix="detail-select"
                                                        placeholder="Select Type"
                                                        options={TASK_TEMPLATE_OPTIONS}
                                                        value={TASK_TEMPLATE_OPTIONS.find((option) => option.value === taskTemplateType) || null}
                                                        onChange={(selectedOption) => {
                                                            onTaskTemplateTypeChange?.(selectedOption?.value || TASK_TEMPLATE_TYPES.NORMAL)
                                                        }}
                                                    />
                                                </div>
                                            )}

                                            <div style={{ display: 'grid', gridTemplateColumns: '96px minmax(0, 1fr)', gap: '24px', alignItems: 'start' }}>
                                                <div style={compactDetailLabelStyle}>Assigned By</div>
                                                <Select
                                                    isDisabled={Boolean(task?.isArchived) || String(task?.Status || '').trim().toLowerCase() === 'archived'}
                                                    styles={compactDetailSelectStyles}
                                                    menuPortalTarget={selectPortalTarget}
                                                    classNamePrefix="detail-select"
                                                    placeholder="None"
                                                    name="Assigner"
                                                    options={users}
                                                    value={task?.Assigner || []}
                                                    onChange={(selectedOptions) => {
                                                        setTask((prevState) => ({
                                                            ...prevState,
                                                            Assigner: selectedOptions,
                                                        }))
                                                    }}
                                                />
                                            </div>

                                            <div style={{ display: 'grid', gridTemplateColumns: '96px minmax(0, 1fr)', gap: '24px', alignItems: 'start' }}>
                                                <div style={compactDetailLabelStyle}>Status<span style={{ color: "red", marginLeft: '4px' }}>*</span></div>
                                               <Select
                                                  //  isDisabled={Boolean(task?.isArchived) || String(task?.Status || '').trim().toLowerCase() === 'archived'}
                                                  isDisabled={Boolean(task?.isArchived)}  
                                                  styles={compactDetailSelectStyles}
                                                    menuPortalTarget={selectPortalTarget}
                                                    classNamePrefix="detail-select"
                                                    placeholder="None"
                                                    name="Status"
                                                    options={statusOptions}
                                                    value={statusOptions.find((option) => String(option.value) === String(task.StatusId)) || null}
                                                    onChange={handleStatusChange}
                                                />
                                            </div>

                                            <div style={{ display: 'grid', gridTemplateColumns: '96px minmax(0, 1fr)', gap: '24px', alignItems: 'start' }}>
                                                <div style={compactDetailLabelStyle}>Assigned To<span style={{ color: 'red', marginLeft: '4px' }}>*</span></div>
                                                <Select
                                                    isDisabled={Boolean(task?.isArchived) || String(task?.Status || '').trim().toLowerCase() === 'archived'}
                                                    styles={compactDetailSelectStyles}
                                                    menuPortalTarget={selectPortalTarget}
                                                    classNamePrefix="detail-select"
                                                    placeholder="Unassigned"
                                                    name="openTo"
                                                    isMulti
                                                    closeMenuOnSelect={false}
                                                    hideSelectedOptions
                                                    getOptionValue={getAssigneeOptionValue}
                                                    onChange={(selectedOptions) => {
                                                        setSelectedAssignee(selectedOptions)
                                                        setTask((prevState) => ({
                                                            ...prevState,
                                                            Assignee: selectedOptions,
                                                        }))
                                                    }}
                                                    value={normalizeSubtaskAssignees(
                                                        task?.Assignee || selectedAssignee || []
                                                    )}
                                                    options={users}
                                                />
                                            </div>

                                            {/* <div style={{ display: 'grid', gridTemplateColumns: '96px minmax(0, 1fr)', gap: '24px', alignItems: 'center' }}>
                                                <div style={compactDetailLabelStyle}>Due Date<span style={{ color: "red", marginLeft: '4px' }}>*</span></div>
                                                <div style={{ display: 'flex', alignItems: 'center', minHeight: '36px', width: '100%' }}>
                                                    <CustomDatePickingFormat
                                                        className={`task-jira-date-input${isTaskDueDateOverdue ? ' task-jira-date-input-overdue' : ''}`}
                                                        disabled={Boolean(task?.isArchived) || String(task?.Status || '').trim().toLowerCase() === 'archived'}
                                                        value={task.DueDate || ''}
                                                        onChange={(value) => {
                                                            handleDateChange(value)
                                                        }}
                                                        inputStyle={{
                                                            border: isTaskDueDateOverdue ? '1px solid rgb(154 18 18)' : '1px solid var(--ui-dashboard-border-strong)',
                                                            borderRadius: '8px',
                                                            padding: '6px 36px 6px 12px',
                                                            minHeight: '32px',
                                                            height: '32px',
                                                            fontSize: '12px',
                                                            fontWeight: 500,
                                                            lineHeight: 1.4,
                                                            color: isTaskDueDateOverdue ? 'rgb(154 18 18)' : 'var(--ui-text-primary)',
                                                            background: 'var(--ui-dashboard-bg)',
                                                            width: '100%',
                                                            opacity: (Boolean(task?.isArchived) || String(task?.Status || '').trim().toLowerCase() === 'archived') ? archivedOpacity : 1,
                                                        }}
                                                    />
                                                </div>
                                            </div> */}
                                            <div style={{ display: 'grid', gridTemplateColumns: '96px minmax(0, 1fr)', gap: '24px', alignItems: 'center' }}>
                                                <div style={compactDetailLabelStyle}>Due Date<span style={{ color: "red", marginLeft: '4px' }}>*</span></div>
                                                <div style={{ display: 'flex', alignItems: 'center', minHeight: '36px', width: '100%' }}>
                                                    <CustomDatePickingFormat
                                                        className={`task-jira-date-input${isTaskDueDateOverdue ? ' task-jira-date-input-overdue' : ''}`}
                                                        disabled={Boolean(task?.isArchived) || String(task?.Status || '').trim().toLowerCase() === 'archived'}
                                                        value={task.DueDate || ''}
                                                        onChange={(value) => {
                                                            handleDateChange(value)
                                                        }}
                                                        inputStyle={{
                                                            border: isTaskDueDateOverdue ? '1px solid rgb(154 18 18)' : '1px solid var(--ui-dashboard-border-strong)',
                                                            borderRadius: '8px',
                                                            padding: '6px 36px 6px 12px',
                                                            minHeight: '32px',
                                                            height: '32px',
                                                            fontSize: '12px',
                                                            fontWeight: 500,
                                                            lineHeight: 1.4,
                                                            color: isTaskDueDateOverdue ? 'rgb(154 18 18)' : 'var(--ui-text-primary)',
                                                            background: 'var(--ui-dashboard-bg)',
                                                            width: '100%',
                                                            opacity: (Boolean(task?.isArchived) || String(task?.Status || '').trim().toLowerCase() === 'archived') ? archivedOpacity : 1,
                                                        }}
                                                    />
                                                </div>
                                            </div>

                                            <div style={{ display: 'grid', gridTemplateColumns: '96px minmax(0, 1fr)', gap: '24px', alignItems: 'center' }}>
                                                <div style={compactDetailLabelStyle}>Reminder</div>
                                                <div style={{ display: 'flex', alignItems: 'center', minHeight: '36px', width: '100%' }}>
                                                    <CustomDatePickingFormat
                                                        className="task-jira-date-input"
                                                        disabled={Boolean(task?.isArchived) || String(task?.Status || '').trim().toLowerCase() === 'archived'}
                                                        value={task.reminderDate || ''}
                                                        onChange={(value) => {
                                                            if (!task?.DueDate) {
                                                                setReminderDateError('Due Date is Not Selected')
                                                                return
                                                            }
                                                            setTask((prev) => ({
                                                                ...prev,
                                                                reminderDate: value,
                                                            }))
                                                            setReminderDateError('')
                                                        }}
                                                        inputStyle={{
                                                            border: '1px solid #E5E7EB',
                                                            borderRadius: '8px',
                                                            padding: '6px 36px 6px 12px',
                                                            minHeight: '32px',
                                                            height: '32px',
                                                            fontSize: '12px',
                                                            fontWeight: 500,
                                                            lineHeight: 1.4,
                                                            color: 'var(--ui-text-primary)',
                                                            background: 'var(--ui-dashboard-bg)',
                                                            width: '100%',
                                                            opacity: (Boolean(task?.isArchived) || String(task?.Status || '').trim().toLowerCase() === 'archived') ? archivedOpacity : 1,
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                            {reminderDateError && !(Boolean(task?.isArchived) || String(task?.Status || '').trim().toLowerCase() === 'archived') && (
                                                <div style={{ display: 'grid', gridTemplateColumns: '96px minmax(0, 1fr)', gap: '24px', alignItems: 'start' }}>
                                                    <div />
                                                    <div style={{ color: '#FF4D4F', fontSize: '12px', lineHeight: 1.3 }}>{reminderDateError}</div>
                                                </div>
                                            )}

                                            <div style={{ display: 'grid', gridTemplateColumns: '96px minmax(0, 1fr)', gap: '24px', alignItems: 'start' }}>
                                                <div style={compactDetailLabelStyle}>Priority<span style={{ color: "red", marginLeft: '4px' }}>*</span></div>
                                                <Select
                                                    isDisabled={Boolean(task?.isArchived) || String(task?.Status || '').trim().toLowerCase() === 'archived'}
                                                    styles={compactDetailSelectStyles}
                                                    menuPortalTarget={selectPortalTarget}
                                                    classNamePrefix="detail-select"
                                                    placeholder="None"
                                                    options={priorityOptions}
                                                    value={priorityOptions.find((option) => option.value === task?.Priority) || null}
                                                    onChange={(selectedOption) => {
                                                        setTask((prevState) => ({
                                                            ...prevState,
                                                            Priority: selectedOption?.value || '',
                                                        }))
                                                    }}
                                                />
                                            </div>

                                            <div style={{ display: 'grid', gridTemplateColumns: '96px minmax(0, 1fr)', gap: '24px', alignItems: 'start' }}>
                                                <div style={compactDetailLabelStyle}>Tags</div>
                                                <div>
                                                    <CFormTextarea
                                                        disabled={Boolean(task?.isArchived) || String(task?.Status || '').trim().toLowerCase() === 'archived'}
                                                        type="text"
                                                        style={{
                                                            borderRadius: '6px',
                                                            border: `1px solid ${isActive && !(Boolean(task?.isArchived) || String(task?.Status || '').trim().toLowerCase() === 'archived') ? 'var(--ui-color-primary)' : 'var(--ui-dashboard-border-strong)'}`,
                                                            transition: 'border 0.2s ease',
                                                            padding: '6px 12px',
                                                            height: '24px',
                                                            fontSize: '12px',
                                                            fontWeight: 500,
                                                            lineHeight: 1.4,
                                                            opacity: (Boolean(task?.isArchived) || String(task?.Status || '').trim().toLowerCase() === 'archived') ? archivedOpacity : 1,
                                                            background: 'var(--ui-dashboard-bg)',
                                                        }}
                                                        placeholder={'Enter the Tags'}
                                                        value={textInput}
                                                        onChange={(e) => {
                                                            setTextInput(e.target.value)
                                                        }}
                                                        onKeyPress={handleKeyPress}
                                                        name="assessment"
                                                        rows={1}
                                                        onFocus={() => !Boolean(task?.isArchived) && setIsFocused(true)}
                                                        onBlur={() => setIsFocused(false)}
                                                    />
                                                    <div style={{ marginTop: '8px', cursor: 'pointer', minHeight: task.Tags?.length ? 'auto' : '0' }} className="d-flex align-items-center flex-wrap gap-2">
                                                        {task.Tags &&
                                                            task.Tags.map((tag, idx) => (
                                                                <CBadge key={idx} className="task-jira-tag-pill d-flex align-items-center gap-2 me-0 mb-0" style={{ cursor: 'pointer', width: 'fit-content', padding: '5px 8px', borderRadius: '999px', fontSize: '12px', fontWeight: 500, marginLeft: 0 }}>
                                                                    <Tag size={10} />
                                                                    <span style={{ maxWidth: '110px', overflowX: 'auto', textOverflow: 'clip', whiteSpace: 'nowrap' }}>{tag.trim()}</span>
                                                                    {!(Boolean(task?.isArchived) || String(task?.Status || '').trim().toLowerCase() === 'archived') && (
                                                                        <X
                                                                            onClick={() => {
                                                                                const fil = task.Tags.filter((tg, i) => i !== idx)
                                                                                setTask((p) => ({
                                                                                    ...p,
                                                                                    Tags: fil,
                                                                                }))
                                                                            }}
                                                                            size={12}
                                                                        />
                                                                    )}
                                                                </CBadge>
                                                            ))}
                                                    </div>                                                </div>                                           </div>
                                        </div>)}
                                </div>
                            </div>
                        </div>
                    </div>
                </CModalBody>

                <CModalFooter style={{
                    borderTop: '1px solid var(--ui-dashboard-border-strong)',
                    display: 'flex',
                    justifyContent: 'center',
                    padding: '16px 24px 24px',
                    borderRadius: '0 0 10px 10px',
                    background: 'var(--ui-dashboard-bg)',
                }}>
                    <CButton
                        variant="outline"
                        className='rs_btn-secondary'
                        style={{ borderRadius: '12px', padding: "10px", minWidth: '90px', backgroundColor: 'transparent', color: 'var(--ui-text-secondary)' }}
                        onClick={() => {
                            if (isCreateMode) {
                                resetTaskState()
                            }
                            setVisible(false)
                        }}
                    >
                        Close
                    </CButton>

                    <CButton
                        style={{ borderRadius: '12px', padding: '10px', minWidth: '90px' }}
                        className='rs_btn-primary'
                        color="primary"
                        disabled={loading || Boolean(task?.isArchived)}
                        onClick={handleCreateTask}
                    >
                        {loading ? (
                            <CSpinner size="sm" />
                        ) : (
                            isCreateMode ? 'Save' : 'Save'
                        )}
                    </CButton>
                </CModalFooter>
            </CModal>

            <CModal
                visible={showDeleteConfirm}
                backdrop="static"
                onClose={handleCancelDeleteSubtask}
                className="hrm-confirm-modal"
                centered>
                <CModalHeader onClose={handleCancelDeleteSubtask}>
                    <CModalTitle>Delete Subtask</CModalTitle>
                </CModalHeader>
                <CModalBody>
                    Are you sure you want to delete this subtask?
                </CModalBody>
                <CModalFooter>
                    <CButton color="secondary" variant="outline" onClick={handleCancelDeleteSubtask}>
                        Cancel
                    </CButton>
                    <CButton color="danger" className="hrm-modal-danger-btn" onClick={handleConfirmDeleteSubtask}>
                        Delete
                    </CButton>
                </CModalFooter>
            </CModal>
            <CModal visible={Boolean(archiveStatusOption)} onClose={() => setArchiveStatusOption(null)} centered backdrop="static" className="hrm-confirm-modal">
                <CModalHeader onClose={() => setArchiveStatusOption(null)}><CModalTitle>Archive Task</CModalTitle></CModalHeader>
                <CModalBody>Are you sure you want to archive this task? Once archived, the status can no longer be modified, but it will still be available for viewing.</CModalBody>
                <CModalFooter>
                    <CButton color="secondary" variant="outline" onClick={() => setArchiveStatusOption(null)}>Cancel</CButton>
                    <CButton color="danger" className="hrm-modal-danger-btn" onClick={handleArchiveConfirm}>Archive</CButton>
                </CModalFooter>
            </CModal>
        </div>
    );
};
export default UpdateTask;
